/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router"

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as appAuthImport } from "./routes/(app)/_auth"
import { Route as authSetNewPasswordRouteImport } from "./routes/(auth)/set-new-password/route"
import { Route as authResetPasswordRouteImport } from "./routes/(auth)/reset-password/route"
import { Route as authLoginRouteImport } from "./routes/(auth)/login/route"
import { Route as appAuthIndexImport } from "./routes/(app)/_auth/index"
import { Route as appAuthSupportChatRouteImport } from "./routes/(app)/_auth/support-chat/route"
import { Route as appAuthSettingsRouteImport } from "./routes/(app)/_auth/settings/route"
import { Route as appAuthReviewsRouteImport } from "./routes/(app)/_auth/reviews/route"
import { Route as appAuthRabattkoderRouteImport } from "./routes/(app)/_auth/rabattkoder/route"
import { Route as appAuthOnboardingRouteImport } from "./routes/(app)/_auth/onboarding/route"
import { Route as appAuthMessagesRouteImport } from "./routes/(app)/_auth/messages/route"
import { Route as appAuthJuloUpdatesRouteImport } from "./routes/(app)/_auth/julo-updates/route"
import { Route as appAuthJobsNewRouteImport } from "./routes/(app)/_auth/jobs-new/route"
import { Route as appAuthJobsRouteImport } from "./routes/(app)/_auth/jobs/route"
import { Route as appAuthEventRouteImport } from "./routes/(app)/_auth/event/route"
import { Route as appAuthCheckInRouteImport } from "./routes/(app)/_auth/check-in/route"
import { Route as appAuthCalendarRouteImport } from "./routes/(app)/_auth/calendar/route"
import { Route as appAuthBookingQrCodeRouteImport } from "./routes/(app)/_auth/booking-qr-code/route"
import { Route as appAuthBikesForSaleRouteImport } from "./routes/(app)/_auth/bikes-for-sale/route"
import { Route as appAuthTrendsIndexImport } from "./routes/(app)/_auth/trends/index"
import { Route as appAuthTireHotelIndexImport } from "./routes/(app)/_auth/tire-hotel/index"
import { Route as appAuthStatistikIndexImport } from "./routes/(app)/_auth/statistik/index"
import { Route as appAuthSimulationSettingsIndexImport } from "./routes/(app)/_auth/simulation-settings/index"
import { Route as appAuthProductsIndexImport } from "./routes/(app)/_auth/products/index"
import { Route as appAuthPriceSimulatorIndexImport } from "./routes/(app)/_auth/price-simulator/index"
import { Route as appAuthPrestationerIndexImport } from "./routes/(app)/_auth/prestationer/index"
import { Route as appAuthInspectionSimulatorIndexImport } from "./routes/(app)/_auth/inspection-simulator/index"
import { Route as appAuthCustomersIndexImport } from "./routes/(app)/_auth/customers/index"
import { Route as appAuthCustomerClubIndexImport } from "./routes/(app)/_auth/customer-club/index"
import { Route as appAuthCompanyJobsIndexImport } from "./routes/(app)/_auth/company-jobs/index"
import { Route as appAuthBikesForSaleIndexImport } from "./routes/(app)/_auth/bikes-for-sale/index"
import { Route as appAuthAutomaticEmailsIndexImport } from "./routes/(app)/_auth/automatic-emails/index"
import { Route as appAuthAllJobsIndexImport } from "./routes/(app)/_auth/all-jobs/index"
import { Route as appAuthAlfredImpactIndexImport } from "./routes/(app)/_auth/alfred-impact/index"
import { Route as appAuthTireHotelTireStorageIdRouteImport } from "./routes/(app)/_auth/tire-hotel/$tireStorageId/route"
import { Route as appAuthSettingsWidgetCustomizationRouteImport } from "./routes/(app)/_auth/settings/widget-customization/route"
import { Route as appAuthSettingsWashRouteImport } from "./routes/(app)/_auth/settings/wash/route"
import { Route as appAuthSettingsUserAccountsRouteImport } from "./routes/(app)/_auth/settings/user-accounts/route"
import { Route as appAuthSettingsTireHotelRouteImport } from "./routes/(app)/_auth/settings/tire-hotel/route"
import { Route as appAuthSettingsStorageLocationsRouteImport } from "./routes/(app)/_auth/settings/storage-locations/route"
import { Route as appAuthSettingsServicesRouteImport } from "./routes/(app)/_auth/settings/services/route"
import { Route as appAuthSettingsServiceRemindersRouteImport } from "./routes/(app)/_auth/settings/service-reminders/route"
import { Route as appAuthSettingsServicePackagesRouteImport } from "./routes/(app)/_auth/settings/service-packages/route"
import { Route as appAuthSettingsReviewsRouteImport } from "./routes/(app)/_auth/settings/reviews/route"
import { Route as appAuthSettingsReceptionRouteImport } from "./routes/(app)/_auth/settings/reception/route"
import { Route as appAuthSettingsPricesRouteImport } from "./routes/(app)/_auth/settings/prices/route"
import { Route as appAuthSettingsPriceListRouteImport } from "./routes/(app)/_auth/settings/price-list/route"
import { Route as appAuthSettingsPartsRouteImport } from "./routes/(app)/_auth/settings/parts/route"
import { Route as appAuthSettingsLeadTimeRouteImport } from "./routes/(app)/_auth/settings/lead-time/route"
import { Route as appAuthSettingsLabelsRouteImport } from "./routes/(app)/_auth/settings/labels/route"
import { Route as appAuthSettingsKassakopplingRouteImport } from "./routes/(app)/_auth/settings/kassakoppling/route"
import { Route as appAuthSettingsFeeRouteImport } from "./routes/(app)/_auth/settings/fee/route"
import { Route as appAuthSettingsEmergencyServiceRouteImport } from "./routes/(app)/_auth/settings/emergency-service/route"
import { Route as appAuthSettingsDamperServiceRouteImport } from "./routes/(app)/_auth/settings/damper-service/route"
import { Route as appAuthSettingsCustomSectionsRouteImport } from "./routes/(app)/_auth/settings/custom-sections/route"
import { Route as appAuthSettingsCompaniesRouteImport } from "./routes/(app)/_auth/settings/companies/route"
import { Route as appAuthSettingsCommunicationRouteImport } from "./routes/(app)/_auth/settings/communication/route"
import { Route as appAuthSettingsBookingOrderRouteImport } from "./routes/(app)/_auth/settings/booking-order/route"
import { Route as appAuthSettingsBookingFormTextRouteImport } from "./routes/(app)/_auth/settings/booking-form-text/route"
import { Route as appAuthSettingsBookableSlotsRouteImport } from "./routes/(app)/_auth/settings/bookable-slots/route"
import { Route as appAuthSettingsBikesForSaleRouteImport } from "./routes/(app)/_auth/settings/bikes-for-sale/route"
import { Route as appAuthSettingsActionVisibilityRouteImport } from "./routes/(app)/_auth/settings/action-visibility/route"
import { Route as appAuthMessagesJobIdRouteImport } from "./routes/(app)/_auth/messages/$jobId/route"
import { Route as appAuthJobsNewReceptionRouteImport } from "./routes/(app)/_auth/jobs/new-reception/route"
import { Route as appAuthJobsCreateRouteImport } from "./routes/(app)/_auth/jobs/create/route"
import { Route as appAuthJobsBookRouteImport } from "./routes/(app)/_auth/jobs/book/route"
import { Route as appAuthJobsJobIdRouteImport } from "./routes/(app)/_auth/jobs/$jobId/route"
import { Route as appAuthEventCreateRouteImport } from "./routes/(app)/_auth/event/create/route"
import { Route as appAuthEventEventIdRouteImport } from "./routes/(app)/_auth/event/$eventId/route"
import { Route as appAuthCustomersCustomerIdRouteImport } from "./routes/(app)/_auth/customers/$customerId/route"
import { Route as appAuthBikesForSaleNewRouteImport } from "./routes/(app)/_auth/bikes-for-sale/new/route"
import { Route as appAuthBikesForSaleInvoicesRouteImport } from "./routes/(app)/_auth/bikes-for-sale/invoices/route"
import { Route as appAuthBikesForSaleBikeIdRouteImport } from "./routes/(app)/_auth/bikes-for-sale/$bikeId/route"
import { Route as appAuthSettingsIndexRouteImport } from "./routes/(app)/_auth/settings/index/route"
import { Route as appAuthJobsIndexRouteImport } from "./routes/(app)/_auth/jobs/index/route"
import { Route as appAuthEventIndexRouteImport } from "./routes/(app)/_auth/event/index/route"
import { Route as appAuthPrestationerMechanicIdIndexImport } from "./routes/(app)/_auth/prestationer/$mechanicId/index"
import { Route as appAuthSettingsCompaniesCompanyIdRouteImport } from "./routes/(app)/_auth/settings/companies/$companyId/route"
import { Route as appAuthSettingsCommunicationTemplatesRouteImport } from "./routes/(app)/_auth/settings/communication/templates/route"
import { Route as appAuthSettingsCommunicationRemindersRouteImport } from "./routes/(app)/_auth/settings/communication/reminders/route"
import { Route as appAuthSettingsCommunicationReceptionRouteImport } from "./routes/(app)/_auth/settings/communication/reception/route"
import { Route as appAuthSettingsCommunicationPickupRouteImport } from "./routes/(app)/_auth/settings/communication/pickup/route"
import { Route as appAuthSettingsCommunicationNotificationsRouteImport } from "./routes/(app)/_auth/settings/communication/notifications/route"
import { Route as appAuthSettingsCommunicationGeneralRouteImport } from "./routes/(app)/_auth/settings/communication/general/route"
import { Route as appAuthSettingsCommunicationBookingRouteImport } from "./routes/(app)/_auth/settings/communication/booking/route"
import { Route as appAuthMessagesCustomersCustomerIdRouteImport } from "./routes/(app)/_auth/messages/customers/$customerId/route"
import { Route as appAuthJobsJobIdNewReceptionRouteImport } from "./routes/(app)/_auth/jobs/$jobId/new-reception/route"
import { Route as appAuthJobsJobIdInspectionRouteImport } from "./routes/(app)/_auth/jobs/$jobId/inspection/route"
import { Route as appAuthEventEventIdEditRouteImport } from "./routes/(app)/_auth/event/$eventId/edit/route"
import { Route as appAuthBikesForSaleBikeIdListingRouteImport } from "./routes/(app)/_auth/bikes-for-sale/$bikeId/listing/route"
import { Route as appAuthBikesForSaleBikeIdInspectionRouteImport } from "./routes/(app)/_auth/bikes-for-sale/$bikeId/inspection/route"
import { Route as appAuthSettingsCompaniesIndexRouteImport } from "./routes/(app)/_auth/settings/companies/index/route"
import { Route as appAuthSettingsCommunicationIndexRouteImport } from "./routes/(app)/_auth/settings/communication/index/route"
import { Route as appAuthCustomersCustomerIdBikesBikeIdRouteImport } from "./routes/(app)/_auth/customers/$customerId/bikes/$bikeId/route"
import { Route as appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteImport } from "./routes/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/route"

// Create Virtual Routes

const appImport = createFileRoute("/(app)")()
const appAuthSettingsInspectionOrderRouteLazyImport = createFileRoute(
  "/(app)/_auth/settings/inspection-order",
)()
const appAuthSettingsBookingRulesAndOpeningHoursRouteLazyImport =
  createFileRoute("/(app)/_auth/settings/booking-rules-and-opening-hours")()
const appAuthJobsJobIdIndexLazyImport = createFileRoute(
  "/(app)/_auth/jobs/$jobId/",
)()
const appAuthEventEventIdIndexLazyImport = createFileRoute(
  "/(app)/_auth/event/$eventId/",
)()
const appAuthCustomersCustomerIdIndexLazyImport = createFileRoute(
  "/(app)/_auth/customers/$customerId/",
)()
const appAuthBikesForSaleBikeIdIndexLazyImport = createFileRoute(
  "/(app)/_auth/bikes-for-sale/$bikeId/",
)()
const appAuthSettingsCompaniesCompanyIdIndexLazyImport = createFileRoute(
  "/(app)/_auth/settings/companies/$companyId/",
)()
const appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyImport =
  createFileRoute(
    "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/",
  )()

// Create/Update Routes

const appRoute = appImport.update({
  id: "/(app)",
  getParentRoute: () => rootRoute,
} as any)

const appAuthRoute = appAuthImport
  .update({
    id: "/_auth",
    getParentRoute: () => appRoute,
  } as any)
  .lazy(() => import("./routes/(app)/_auth.lazy").then((d) => d.Route))

const authSetNewPasswordRouteRoute = authSetNewPasswordRouteImport
  .update({
    id: "/(auth)/set-new-password",
    path: "/set-new-password",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import("./routes/(auth)/set-new-password/route.lazy").then((d) => d.Route),
  )

const authResetPasswordRouteRoute = authResetPasswordRouteImport
  .update({
    id: "/(auth)/reset-password",
    path: "/reset-password",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import("./routes/(auth)/reset-password/route.lazy").then((d) => d.Route),
  )

const authLoginRouteRoute = authLoginRouteImport
  .update({
    id: "/(auth)/login",
    path: "/login",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(auth)/login/route.lazy").then((d) => d.Route))

const appAuthIndexRoute = appAuthIndexImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() => import("./routes/(app)/_auth/index.lazy").then((d) => d.Route))

const appAuthSupportChatRouteRoute = appAuthSupportChatRouteImport
  .update({
    id: "/support-chat",
    path: "/support-chat",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/support-chat/route.lazy").then((d) => d.Route),
  )

const appAuthSettingsRouteRoute = appAuthSettingsRouteImport
  .update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/route.lazy").then((d) => d.Route),
  )

const appAuthReviewsRouteRoute = appAuthReviewsRouteImport
  .update({
    id: "/reviews",
    path: "/reviews",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/reviews/route.lazy").then((d) => d.Route),
  )

const appAuthRabattkoderRouteRoute = appAuthRabattkoderRouteImport
  .update({
    id: "/rabattkoder",
    path: "/rabattkoder",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/rabattkoder/route.lazy").then((d) => d.Route),
  )

const appAuthOnboardingRouteRoute = appAuthOnboardingRouteImport
  .update({
    id: "/onboarding",
    path: "/onboarding",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/onboarding/route.lazy").then((d) => d.Route),
  )

const appAuthMessagesRouteRoute = appAuthMessagesRouteImport
  .update({
    id: "/messages",
    path: "/messages",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/messages/route.lazy").then((d) => d.Route),
  )

const appAuthJuloUpdatesRouteRoute = appAuthJuloUpdatesRouteImport
  .update({
    id: "/julo-updates",
    path: "/julo-updates",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/julo-updates/route.lazy").then((d) => d.Route),
  )

const appAuthJobsNewRouteRoute = appAuthJobsNewRouteImport.update({
  id: "/jobs-new",
  path: "/jobs-new",
  getParentRoute: () => appAuthRoute,
} as any)

const appAuthJobsRouteRoute = appAuthJobsRouteImport.update({
  id: "/jobs",
  path: "/jobs",
  getParentRoute: () => appAuthRoute,
} as any)

const appAuthEventRouteRoute = appAuthEventRouteImport
  .update({
    id: "/event",
    path: "/event",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/event/route.lazy").then((d) => d.Route),
  )

const appAuthCheckInRouteRoute = appAuthCheckInRouteImport
  .update({
    id: "/check-in",
    path: "/check-in",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/check-in/route.lazy").then((d) => d.Route),
  )

const appAuthCalendarRouteRoute = appAuthCalendarRouteImport
  .update({
    id: "/calendar",
    path: "/calendar",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/calendar/route.lazy").then((d) => d.Route),
  )

const appAuthBookingQrCodeRouteRoute = appAuthBookingQrCodeRouteImport
  .update({
    id: "/booking-qr-code",
    path: "/booking-qr-code",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/booking-qr-code/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthBikesForSaleRouteRoute = appAuthBikesForSaleRouteImport
  .update({
    id: "/bikes-for-sale",
    path: "/bikes-for-sale",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/bikes-for-sale/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthTrendsIndexRoute = appAuthTrendsIndexImport.update({
  id: "/trends/",
  path: "/trends/",
  getParentRoute: () => appAuthRoute,
} as any)

const appAuthTireHotelIndexRoute = appAuthTireHotelIndexImport
  .update({
    id: "/tire-hotel/",
    path: "/tire-hotel/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/tire-hotel/index.lazy").then((d) => d.Route),
  )

const appAuthStatistikIndexRoute = appAuthStatistikIndexImport
  .update({
    id: "/statistik/",
    path: "/statistik/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/statistik/index.lazy").then((d) => d.Route),
  )

const appAuthSimulationSettingsIndexRoute = appAuthSimulationSettingsIndexImport
  .update({
    id: "/simulation-settings/",
    path: "/simulation-settings/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/simulation-settings/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthProductsIndexRoute = appAuthProductsIndexImport
  .update({
    id: "/products/",
    path: "/products/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/products/index.lazy").then((d) => d.Route),
  )

const appAuthPriceSimulatorIndexRoute = appAuthPriceSimulatorIndexImport
  .update({
    id: "/price-simulator/",
    path: "/price-simulator/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/price-simulator/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthPrestationerIndexRoute = appAuthPrestationerIndexImport
  .update({
    id: "/prestationer/",
    path: "/prestationer/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/prestationer/index.lazy").then((d) => d.Route),
  )

const appAuthInspectionSimulatorIndexRoute =
  appAuthInspectionSimulatorIndexImport
    .update({
      id: "/inspection-simulator/",
      path: "/inspection-simulator/",
      getParentRoute: () => appAuthRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/inspection-simulator/index.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthCustomersIndexRoute = appAuthCustomersIndexImport
  .update({
    id: "/customers/",
    path: "/customers/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/customers/index.lazy").then((d) => d.Route),
  )

const appAuthCustomerClubIndexRoute = appAuthCustomerClubIndexImport
  .update({
    id: "/customer-club/",
    path: "/customer-club/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/customer-club/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthCompanyJobsIndexRoute = appAuthCompanyJobsIndexImport
  .update({
    id: "/company-jobs/",
    path: "/company-jobs/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/company-jobs/index.lazy").then((d) => d.Route),
  )

const appAuthBikesForSaleIndexRoute = appAuthBikesForSaleIndexImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthBikesForSaleRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/bikes-for-sale/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthAutomaticEmailsIndexRoute = appAuthAutomaticEmailsIndexImport
  .update({
    id: "/automatic-emails/",
    path: "/automatic-emails/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/automatic-emails/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthAllJobsIndexRoute = appAuthAllJobsIndexImport
  .update({
    id: "/all-jobs/",
    path: "/all-jobs/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/all-jobs/index.lazy").then((d) => d.Route),
  )

const appAuthAlfredImpactIndexRoute = appAuthAlfredImpactIndexImport
  .update({
    id: "/alfred-impact/",
    path: "/alfred-impact/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/alfred-impact/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsInspectionOrderRouteLazyRoute =
  appAuthSettingsInspectionOrderRouteLazyImport
    .update({
      id: "/inspection-order",
      path: "/inspection-order",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/inspection-order/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute =
  appAuthSettingsBookingRulesAndOpeningHoursRouteLazyImport
    .update({
      id: "/booking-rules-and-opening-hours",
      path: "/booking-rules-and-opening-hours",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/booking-rules-and-opening-hours/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthTireHotelTireStorageIdRouteRoute =
  appAuthTireHotelTireStorageIdRouteImport
    .update({
      id: "/tire-hotel/$tireStorageId",
      path: "/tire-hotel/$tireStorageId",
      getParentRoute: () => appAuthRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/tire-hotel/$tireStorageId/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsWidgetCustomizationRouteRoute =
  appAuthSettingsWidgetCustomizationRouteImport
    .update({
      id: "/widget-customization",
      path: "/widget-customization",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/widget-customization/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsWashRouteRoute = appAuthSettingsWashRouteImport
  .update({
    id: "/wash",
    path: "/wash",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/wash/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsUserAccountsRouteRoute =
  appAuthSettingsUserAccountsRouteImport
    .update({
      id: "/user-accounts",
      path: "/user-accounts",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/user-accounts/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsTireHotelRouteRoute = appAuthSettingsTireHotelRouteImport
  .update({
    id: "/tire-hotel",
    path: "/tire-hotel",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/tire-hotel/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsStorageLocationsRouteRoute =
  appAuthSettingsStorageLocationsRouteImport
    .update({
      id: "/storage-locations",
      path: "/storage-locations",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/storage-locations/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsServicesRouteRoute = appAuthSettingsServicesRouteImport
  .update({
    id: "/services",
    path: "/services",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/services/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsServiceRemindersRouteRoute =
  appAuthSettingsServiceRemindersRouteImport
    .update({
      id: "/service-reminders",
      path: "/service-reminders",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/service-reminders/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsServicePackagesRouteRoute =
  appAuthSettingsServicePackagesRouteImport
    .update({
      id: "/service-packages",
      path: "/service-packages",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/service-packages/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsReviewsRouteRoute = appAuthSettingsReviewsRouteImport
  .update({
    id: "/reviews",
    path: "/reviews",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/reviews/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsReceptionRouteRoute = appAuthSettingsReceptionRouteImport
  .update({
    id: "/reception",
    path: "/reception",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/reception/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsPricesRouteRoute = appAuthSettingsPricesRouteImport
  .update({
    id: "/prices",
    path: "/prices",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/prices/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsPriceListRouteRoute = appAuthSettingsPriceListRouteImport
  .update({
    id: "/price-list",
    path: "/price-list",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/price-list/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsPartsRouteRoute = appAuthSettingsPartsRouteImport
  .update({
    id: "/parts",
    path: "/parts",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/parts/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsLeadTimeRouteRoute = appAuthSettingsLeadTimeRouteImport
  .update({
    id: "/lead-time",
    path: "/lead-time",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/lead-time/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsLabelsRouteRoute = appAuthSettingsLabelsRouteImport
  .update({
    id: "/labels",
    path: "/labels",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/labels/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsKassakopplingRouteRoute =
  appAuthSettingsKassakopplingRouteImport
    .update({
      id: "/kassakoppling",
      path: "/kassakoppling",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/kassakoppling/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsFeeRouteRoute = appAuthSettingsFeeRouteImport
  .update({
    id: "/fee",
    path: "/fee",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/fee/route.lazy").then((d) => d.Route),
  )

const appAuthSettingsEmergencyServiceRouteRoute =
  appAuthSettingsEmergencyServiceRouteImport
    .update({
      id: "/emergency-service",
      path: "/emergency-service",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/emergency-service/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsDamperServiceRouteRoute =
  appAuthSettingsDamperServiceRouteImport
    .update({
      id: "/damper-service",
      path: "/damper-service",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/damper-service/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsCustomSectionsRouteRoute =
  appAuthSettingsCustomSectionsRouteImport
    .update({
      id: "/custom-sections",
      path: "/custom-sections",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/custom-sections/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsCompaniesRouteRoute = appAuthSettingsCompaniesRouteImport
  .update({
    id: "/companies",
    path: "/companies",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/companies/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthSettingsCommunicationRouteRoute =
  appAuthSettingsCommunicationRouteImport
    .update({
      id: "/communication",
      path: "/communication",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/communication/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsBookingOrderRouteRoute =
  appAuthSettingsBookingOrderRouteImport
    .update({
      id: "/booking-order",
      path: "/booking-order",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/booking-order/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsBookingFormTextRouteRoute =
  appAuthSettingsBookingFormTextRouteImport
    .update({
      id: "/booking-form-text",
      path: "/booking-form-text",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/booking-form-text/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsBookableSlotsRouteRoute =
  appAuthSettingsBookableSlotsRouteImport
    .update({
      id: "/bookable-slots",
      path: "/bookable-slots",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/bookable-slots/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsBikesForSaleRouteRoute =
  appAuthSettingsBikesForSaleRouteImport
    .update({
      id: "/bikes-for-sale",
      path: "/bikes-for-sale",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/bikes-for-sale/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsActionVisibilityRouteRoute =
  appAuthSettingsActionVisibilityRouteImport
    .update({
      id: "/action-visibility",
      path: "/action-visibility",
      getParentRoute: () => appAuthSettingsRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/action-visibility/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthMessagesJobIdRouteRoute = appAuthMessagesJobIdRouteImport
  .update({
    id: "/$jobId",
    path: "/$jobId",
    getParentRoute: () => appAuthMessagesRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/messages/$jobId/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthJobsNewReceptionRouteRoute = appAuthJobsNewReceptionRouteImport
  .update({
    id: "/new-reception",
    path: "/new-reception",
    getParentRoute: () => appAuthJobsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/jobs/new-reception/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthJobsCreateRouteRoute = appAuthJobsCreateRouteImport.update({
  id: "/create",
  path: "/create",
  getParentRoute: () => appAuthJobsRouteRoute,
} as any)

const appAuthJobsBookRouteRoute = appAuthJobsBookRouteImport
  .update({
    id: "/book",
    path: "/book",
    getParentRoute: () => appAuthJobsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/jobs/book/route.lazy").then((d) => d.Route),
  )

const appAuthJobsJobIdRouteRoute = appAuthJobsJobIdRouteImport.update({
  id: "/$jobId",
  path: "/$jobId",
  getParentRoute: () => appAuthJobsRouteRoute,
} as any)

const appAuthEventCreateRouteRoute = appAuthEventCreateRouteImport
  .update({
    id: "/create",
    path: "/create",
    getParentRoute: () => appAuthEventRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/event/create/route.lazy").then((d) => d.Route),
  )

const appAuthEventEventIdRouteRoute = appAuthEventEventIdRouteImport.update({
  id: "/$eventId",
  path: "/$eventId",
  getParentRoute: () => appAuthEventRouteRoute,
} as any)

const appAuthCustomersCustomerIdRouteRoute =
  appAuthCustomersCustomerIdRouteImport.update({
    id: "/customers/$customerId",
    path: "/customers/$customerId",
    getParentRoute: () => appAuthRoute,
  } as any)

const appAuthBikesForSaleNewRouteRoute = appAuthBikesForSaleNewRouteImport
  .update({
    id: "/new",
    path: "/new",
    getParentRoute: () => appAuthBikesForSaleRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/bikes-for-sale/new/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthBikesForSaleInvoicesRouteRoute =
  appAuthBikesForSaleInvoicesRouteImport
    .update({
      id: "/invoices",
      path: "/invoices",
      getParentRoute: () => appAuthBikesForSaleRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/bikes-for-sale/invoices/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthBikesForSaleBikeIdRouteRoute =
  appAuthBikesForSaleBikeIdRouteImport.update({
    id: "/$bikeId",
    path: "/$bikeId",
    getParentRoute: () => appAuthBikesForSaleRouteRoute,
  } as any)

const appAuthSettingsIndexRouteRoute = appAuthSettingsIndexRouteImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthSettingsRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/settings/index/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthJobsIndexRouteRoute = appAuthJobsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => appAuthJobsRouteRoute,
} as any)

const appAuthEventIndexRouteRoute = appAuthEventIndexRouteImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthEventRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/event/index/route.lazy").then((d) => d.Route),
  )

const appAuthJobsJobIdIndexLazyRoute = appAuthJobsJobIdIndexLazyImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthJobsJobIdRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/jobs/$jobId/index.lazy").then((d) => d.Route),
  )

const appAuthEventEventIdIndexLazyRoute = appAuthEventEventIdIndexLazyImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthEventEventIdRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/event/$eventId/index.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthCustomersCustomerIdIndexLazyRoute =
  appAuthCustomersCustomerIdIndexLazyImport
    .update({
      id: "/",
      path: "/",
      getParentRoute: () => appAuthCustomersCustomerIdRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/customers/$customerId/index.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthBikesForSaleBikeIdIndexLazyRoute =
  appAuthBikesForSaleBikeIdIndexLazyImport
    .update({
      id: "/",
      path: "/",
      getParentRoute: () => appAuthBikesForSaleBikeIdRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/bikes-for-sale/$bikeId/index.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthPrestationerMechanicIdIndexRoute =
  appAuthPrestationerMechanicIdIndexImport
    .update({
      id: "/prestationer/$mechanicId/",
      path: "/prestationer/$mechanicId/",
      getParentRoute: () => appAuthRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/prestationer/$mechanicId/index.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsCompaniesCompanyIdRouteRoute =
  appAuthSettingsCompaniesCompanyIdRouteImport.update({
    id: "/$companyId",
    path: "/$companyId",
    getParentRoute: () => appAuthSettingsCompaniesRouteRoute,
  } as any)

const appAuthSettingsCommunicationTemplatesRouteRoute =
  appAuthSettingsCommunicationTemplatesRouteImport
    .update({
      id: "/templates",
      path: "/templates",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/templates/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCommunicationRemindersRouteRoute =
  appAuthSettingsCommunicationRemindersRouteImport
    .update({
      id: "/reminders",
      path: "/reminders",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/reminders/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCommunicationReceptionRouteRoute =
  appAuthSettingsCommunicationReceptionRouteImport
    .update({
      id: "/reception",
      path: "/reception",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/reception/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCommunicationPickupRouteRoute =
  appAuthSettingsCommunicationPickupRouteImport.update({
    id: "/pickup",
    path: "/pickup",
    getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
  } as any)

const appAuthSettingsCommunicationNotificationsRouteRoute =
  appAuthSettingsCommunicationNotificationsRouteImport
    .update({
      id: "/notifications",
      path: "/notifications",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/notifications/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCommunicationGeneralRouteRoute =
  appAuthSettingsCommunicationGeneralRouteImport
    .update({
      id: "/general",
      path: "/general",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/general/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCommunicationBookingRouteRoute =
  appAuthSettingsCommunicationBookingRouteImport
    .update({
      id: "/booking",
      path: "/booking",
      getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/communication/booking/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthMessagesCustomersCustomerIdRouteRoute =
  appAuthMessagesCustomersCustomerIdRouteImport
    .update({
      id: "/customers/$customerId",
      path: "/customers/$customerId",
      getParentRoute: () => appAuthMessagesRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/messages/customers/$customerId/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthJobsJobIdNewReceptionRouteRoute =
  appAuthJobsJobIdNewReceptionRouteImport
    .update({
      id: "/new-reception",
      path: "/new-reception",
      getParentRoute: () => appAuthJobsJobIdRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/jobs/$jobId/new-reception/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthJobsJobIdInspectionRouteRoute =
  appAuthJobsJobIdInspectionRouteImport
    .update({
      id: "/inspection",
      path: "/inspection",
      getParentRoute: () => appAuthJobsJobIdRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/jobs/$jobId/inspection/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthEventEventIdEditRouteRoute = appAuthEventEventIdEditRouteImport
  .update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => appAuthEventEventIdRouteRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/event/$eventId/edit/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthBikesForSaleBikeIdListingRouteRoute =
  appAuthBikesForSaleBikeIdListingRouteImport
    .update({
      id: "/listing",
      path: "/listing",
      getParentRoute: () => appAuthBikesForSaleBikeIdRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/bikes-for-sale/$bikeId/listing/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthBikesForSaleBikeIdInspectionRouteRoute =
  appAuthBikesForSaleBikeIdInspectionRouteImport
    .update({
      id: "/inspection",
      path: "/inspection",
      getParentRoute: () => appAuthBikesForSaleBikeIdRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/bikes-for-sale/$bikeId/inspection/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthSettingsCompaniesIndexRouteRoute =
  appAuthSettingsCompaniesIndexRouteImport
    .update({
      id: "/",
      path: "/",
      getParentRoute: () => appAuthSettingsCompaniesRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/settings/companies/index/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthSettingsCommunicationIndexRouteRoute =
  appAuthSettingsCommunicationIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthSettingsCommunicationRouteRoute,
  } as any)

const appAuthSettingsCompaniesCompanyIdIndexLazyRoute =
  appAuthSettingsCompaniesCompanyIdIndexLazyImport
    .update({
      id: "/",
      path: "/",
      getParentRoute: () => appAuthSettingsCompaniesCompanyIdRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/settings/companies/$companyId/index.lazy"
      ).then((d) => d.Route),
    )

const appAuthCustomersCustomerIdBikesBikeIdRouteRoute =
  appAuthCustomersCustomerIdBikesBikeIdRouteImport
    .update({
      id: "/bikes/$bikeId",
      path: "/bikes/$bikeId",
      getParentRoute: () => appAuthCustomersCustomerIdRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/customers/$customerId/bikes/$bikeId/route.lazy"
      ).then((d) => d.Route),
    )

const appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRoute =
  appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteImport.update({
    id: "/companies/$companyId/fakturor/$invoiceNumber",
    path: "/companies/$companyId/fakturor/$invoiceNumber",
    getParentRoute: () => appAuthRoute,
  } as any)

const appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute =
  appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyImport
    .update({
      id: "/",
      path: "/",
      getParentRoute: () =>
        appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/index.lazy"
      ).then((d) => d.Route),
    )

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/(auth)/login": {
      id: "/(auth)/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRoute
    }
    "/(auth)/reset-password": {
      id: "/(auth)/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRoute
    }
    "/(auth)/set-new-password": {
      id: "/(auth)/set-new-password"
      path: "/set-new-password"
      fullPath: "/set-new-password"
      preLoaderRoute: typeof authSetNewPasswordRouteImport
      parentRoute: typeof rootRoute
    }
    "/(app)": {
      id: "/(app)"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    "/(app)/_auth": {
      id: "/(app)/_auth"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appAuthImport
      parentRoute: typeof appRoute
    }
    "/(app)/_auth/bikes-for-sale": {
      id: "/(app)/_auth/bikes-for-sale"
      path: "/bikes-for-sale"
      fullPath: "/bikes-for-sale"
      preLoaderRoute: typeof appAuthBikesForSaleRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/booking-qr-code": {
      id: "/(app)/_auth/booking-qr-code"
      path: "/booking-qr-code"
      fullPath: "/booking-qr-code"
      preLoaderRoute: typeof appAuthBookingQrCodeRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/calendar": {
      id: "/(app)/_auth/calendar"
      path: "/calendar"
      fullPath: "/calendar"
      preLoaderRoute: typeof appAuthCalendarRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/check-in": {
      id: "/(app)/_auth/check-in"
      path: "/check-in"
      fullPath: "/check-in"
      preLoaderRoute: typeof appAuthCheckInRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/event": {
      id: "/(app)/_auth/event"
      path: "/event"
      fullPath: "/event"
      preLoaderRoute: typeof appAuthEventRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/jobs": {
      id: "/(app)/_auth/jobs"
      path: "/jobs"
      fullPath: "/jobs"
      preLoaderRoute: typeof appAuthJobsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/jobs-new": {
      id: "/(app)/_auth/jobs-new"
      path: "/jobs-new"
      fullPath: "/jobs-new"
      preLoaderRoute: typeof appAuthJobsNewRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/julo-updates": {
      id: "/(app)/_auth/julo-updates"
      path: "/julo-updates"
      fullPath: "/julo-updates"
      preLoaderRoute: typeof appAuthJuloUpdatesRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/messages": {
      id: "/(app)/_auth/messages"
      path: "/messages"
      fullPath: "/messages"
      preLoaderRoute: typeof appAuthMessagesRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/onboarding": {
      id: "/(app)/_auth/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof appAuthOnboardingRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/rabattkoder": {
      id: "/(app)/_auth/rabattkoder"
      path: "/rabattkoder"
      fullPath: "/rabattkoder"
      preLoaderRoute: typeof appAuthRabattkoderRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/reviews": {
      id: "/(app)/_auth/reviews"
      path: "/reviews"
      fullPath: "/reviews"
      preLoaderRoute: typeof appAuthReviewsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/settings": {
      id: "/(app)/_auth/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof appAuthSettingsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/support-chat": {
      id: "/(app)/_auth/support-chat"
      path: "/support-chat"
      fullPath: "/support-chat"
      preLoaderRoute: typeof appAuthSupportChatRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/": {
      id: "/(app)/_auth/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appAuthIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/event/": {
      id: "/(app)/_auth/event/"
      path: "/"
      fullPath: "/event/"
      preLoaderRoute: typeof appAuthEventIndexRouteImport
      parentRoute: typeof appAuthEventRouteImport
    }
    "/(app)/_auth/jobs/": {
      id: "/(app)/_auth/jobs/"
      path: "/"
      fullPath: "/jobs/"
      preLoaderRoute: typeof appAuthJobsIndexRouteImport
      parentRoute: typeof appAuthJobsRouteImport
    }
    "/(app)/_auth/settings/": {
      id: "/(app)/_auth/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof appAuthSettingsIndexRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/bikes-for-sale/$bikeId": {
      id: "/(app)/_auth/bikes-for-sale/$bikeId"
      path: "/$bikeId"
      fullPath: "/bikes-for-sale/$bikeId"
      preLoaderRoute: typeof appAuthBikesForSaleBikeIdRouteImport
      parentRoute: typeof appAuthBikesForSaleRouteImport
    }
    "/(app)/_auth/bikes-for-sale/invoices": {
      id: "/(app)/_auth/bikes-for-sale/invoices"
      path: "/invoices"
      fullPath: "/bikes-for-sale/invoices"
      preLoaderRoute: typeof appAuthBikesForSaleInvoicesRouteImport
      parentRoute: typeof appAuthBikesForSaleRouteImport
    }
    "/(app)/_auth/bikes-for-sale/new": {
      id: "/(app)/_auth/bikes-for-sale/new"
      path: "/new"
      fullPath: "/bikes-for-sale/new"
      preLoaderRoute: typeof appAuthBikesForSaleNewRouteImport
      parentRoute: typeof appAuthBikesForSaleRouteImport
    }
    "/(app)/_auth/customers/$customerId": {
      id: "/(app)/_auth/customers/$customerId"
      path: "/customers/$customerId"
      fullPath: "/customers/$customerId"
      preLoaderRoute: typeof appAuthCustomersCustomerIdRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/event/$eventId": {
      id: "/(app)/_auth/event/$eventId"
      path: "/$eventId"
      fullPath: "/event/$eventId"
      preLoaderRoute: typeof appAuthEventEventIdRouteImport
      parentRoute: typeof appAuthEventRouteImport
    }
    "/(app)/_auth/event/create": {
      id: "/(app)/_auth/event/create"
      path: "/create"
      fullPath: "/event/create"
      preLoaderRoute: typeof appAuthEventCreateRouteImport
      parentRoute: typeof appAuthEventRouteImport
    }
    "/(app)/_auth/jobs/$jobId": {
      id: "/(app)/_auth/jobs/$jobId"
      path: "/$jobId"
      fullPath: "/jobs/$jobId"
      preLoaderRoute: typeof appAuthJobsJobIdRouteImport
      parentRoute: typeof appAuthJobsRouteImport
    }
    "/(app)/_auth/jobs/book": {
      id: "/(app)/_auth/jobs/book"
      path: "/book"
      fullPath: "/jobs/book"
      preLoaderRoute: typeof appAuthJobsBookRouteImport
      parentRoute: typeof appAuthJobsRouteImport
    }
    "/(app)/_auth/jobs/create": {
      id: "/(app)/_auth/jobs/create"
      path: "/create"
      fullPath: "/jobs/create"
      preLoaderRoute: typeof appAuthJobsCreateRouteImport
      parentRoute: typeof appAuthJobsRouteImport
    }
    "/(app)/_auth/jobs/new-reception": {
      id: "/(app)/_auth/jobs/new-reception"
      path: "/new-reception"
      fullPath: "/jobs/new-reception"
      preLoaderRoute: typeof appAuthJobsNewReceptionRouteImport
      parentRoute: typeof appAuthJobsRouteImport
    }
    "/(app)/_auth/messages/$jobId": {
      id: "/(app)/_auth/messages/$jobId"
      path: "/$jobId"
      fullPath: "/messages/$jobId"
      preLoaderRoute: typeof appAuthMessagesJobIdRouteImport
      parentRoute: typeof appAuthMessagesRouteImport
    }
    "/(app)/_auth/settings/action-visibility": {
      id: "/(app)/_auth/settings/action-visibility"
      path: "/action-visibility"
      fullPath: "/settings/action-visibility"
      preLoaderRoute: typeof appAuthSettingsActionVisibilityRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/bikes-for-sale": {
      id: "/(app)/_auth/settings/bikes-for-sale"
      path: "/bikes-for-sale"
      fullPath: "/settings/bikes-for-sale"
      preLoaderRoute: typeof appAuthSettingsBikesForSaleRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/bookable-slots": {
      id: "/(app)/_auth/settings/bookable-slots"
      path: "/bookable-slots"
      fullPath: "/settings/bookable-slots"
      preLoaderRoute: typeof appAuthSettingsBookableSlotsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/booking-form-text": {
      id: "/(app)/_auth/settings/booking-form-text"
      path: "/booking-form-text"
      fullPath: "/settings/booking-form-text"
      preLoaderRoute: typeof appAuthSettingsBookingFormTextRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/booking-order": {
      id: "/(app)/_auth/settings/booking-order"
      path: "/booking-order"
      fullPath: "/settings/booking-order"
      preLoaderRoute: typeof appAuthSettingsBookingOrderRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/communication": {
      id: "/(app)/_auth/settings/communication"
      path: "/communication"
      fullPath: "/settings/communication"
      preLoaderRoute: typeof appAuthSettingsCommunicationRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/companies": {
      id: "/(app)/_auth/settings/companies"
      path: "/companies"
      fullPath: "/settings/companies"
      preLoaderRoute: typeof appAuthSettingsCompaniesRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/custom-sections": {
      id: "/(app)/_auth/settings/custom-sections"
      path: "/custom-sections"
      fullPath: "/settings/custom-sections"
      preLoaderRoute: typeof appAuthSettingsCustomSectionsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/damper-service": {
      id: "/(app)/_auth/settings/damper-service"
      path: "/damper-service"
      fullPath: "/settings/damper-service"
      preLoaderRoute: typeof appAuthSettingsDamperServiceRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/emergency-service": {
      id: "/(app)/_auth/settings/emergency-service"
      path: "/emergency-service"
      fullPath: "/settings/emergency-service"
      preLoaderRoute: typeof appAuthSettingsEmergencyServiceRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/fee": {
      id: "/(app)/_auth/settings/fee"
      path: "/fee"
      fullPath: "/settings/fee"
      preLoaderRoute: typeof appAuthSettingsFeeRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/kassakoppling": {
      id: "/(app)/_auth/settings/kassakoppling"
      path: "/kassakoppling"
      fullPath: "/settings/kassakoppling"
      preLoaderRoute: typeof appAuthSettingsKassakopplingRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/labels": {
      id: "/(app)/_auth/settings/labels"
      path: "/labels"
      fullPath: "/settings/labels"
      preLoaderRoute: typeof appAuthSettingsLabelsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/lead-time": {
      id: "/(app)/_auth/settings/lead-time"
      path: "/lead-time"
      fullPath: "/settings/lead-time"
      preLoaderRoute: typeof appAuthSettingsLeadTimeRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/parts": {
      id: "/(app)/_auth/settings/parts"
      path: "/parts"
      fullPath: "/settings/parts"
      preLoaderRoute: typeof appAuthSettingsPartsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/price-list": {
      id: "/(app)/_auth/settings/price-list"
      path: "/price-list"
      fullPath: "/settings/price-list"
      preLoaderRoute: typeof appAuthSettingsPriceListRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/prices": {
      id: "/(app)/_auth/settings/prices"
      path: "/prices"
      fullPath: "/settings/prices"
      preLoaderRoute: typeof appAuthSettingsPricesRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/reception": {
      id: "/(app)/_auth/settings/reception"
      path: "/reception"
      fullPath: "/settings/reception"
      preLoaderRoute: typeof appAuthSettingsReceptionRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/reviews": {
      id: "/(app)/_auth/settings/reviews"
      path: "/reviews"
      fullPath: "/settings/reviews"
      preLoaderRoute: typeof appAuthSettingsReviewsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/service-packages": {
      id: "/(app)/_auth/settings/service-packages"
      path: "/service-packages"
      fullPath: "/settings/service-packages"
      preLoaderRoute: typeof appAuthSettingsServicePackagesRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/service-reminders": {
      id: "/(app)/_auth/settings/service-reminders"
      path: "/service-reminders"
      fullPath: "/settings/service-reminders"
      preLoaderRoute: typeof appAuthSettingsServiceRemindersRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/services": {
      id: "/(app)/_auth/settings/services"
      path: "/services"
      fullPath: "/settings/services"
      preLoaderRoute: typeof appAuthSettingsServicesRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/storage-locations": {
      id: "/(app)/_auth/settings/storage-locations"
      path: "/storage-locations"
      fullPath: "/settings/storage-locations"
      preLoaderRoute: typeof appAuthSettingsStorageLocationsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/tire-hotel": {
      id: "/(app)/_auth/settings/tire-hotel"
      path: "/tire-hotel"
      fullPath: "/settings/tire-hotel"
      preLoaderRoute: typeof appAuthSettingsTireHotelRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/user-accounts": {
      id: "/(app)/_auth/settings/user-accounts"
      path: "/user-accounts"
      fullPath: "/settings/user-accounts"
      preLoaderRoute: typeof appAuthSettingsUserAccountsRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/wash": {
      id: "/(app)/_auth/settings/wash"
      path: "/wash"
      fullPath: "/settings/wash"
      preLoaderRoute: typeof appAuthSettingsWashRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/widget-customization": {
      id: "/(app)/_auth/settings/widget-customization"
      path: "/widget-customization"
      fullPath: "/settings/widget-customization"
      preLoaderRoute: typeof appAuthSettingsWidgetCustomizationRouteImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/tire-hotel/$tireStorageId": {
      id: "/(app)/_auth/tire-hotel/$tireStorageId"
      path: "/tire-hotel/$tireStorageId"
      fullPath: "/tire-hotel/$tireStorageId"
      preLoaderRoute: typeof appAuthTireHotelTireStorageIdRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/settings/booking-rules-and-opening-hours": {
      id: "/(app)/_auth/settings/booking-rules-and-opening-hours"
      path: "/booking-rules-and-opening-hours"
      fullPath: "/settings/booking-rules-and-opening-hours"
      preLoaderRoute: typeof appAuthSettingsBookingRulesAndOpeningHoursRouteLazyImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/settings/inspection-order": {
      id: "/(app)/_auth/settings/inspection-order"
      path: "/inspection-order"
      fullPath: "/settings/inspection-order"
      preLoaderRoute: typeof appAuthSettingsInspectionOrderRouteLazyImport
      parentRoute: typeof appAuthSettingsRouteImport
    }
    "/(app)/_auth/alfred-impact/": {
      id: "/(app)/_auth/alfred-impact/"
      path: "/alfred-impact"
      fullPath: "/alfred-impact"
      preLoaderRoute: typeof appAuthAlfredImpactIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/all-jobs/": {
      id: "/(app)/_auth/all-jobs/"
      path: "/all-jobs"
      fullPath: "/all-jobs"
      preLoaderRoute: typeof appAuthAllJobsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/automatic-emails/": {
      id: "/(app)/_auth/automatic-emails/"
      path: "/automatic-emails"
      fullPath: "/automatic-emails"
      preLoaderRoute: typeof appAuthAutomaticEmailsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/bikes-for-sale/": {
      id: "/(app)/_auth/bikes-for-sale/"
      path: "/"
      fullPath: "/bikes-for-sale/"
      preLoaderRoute: typeof appAuthBikesForSaleIndexImport
      parentRoute: typeof appAuthBikesForSaleRouteImport
    }
    "/(app)/_auth/company-jobs/": {
      id: "/(app)/_auth/company-jobs/"
      path: "/company-jobs"
      fullPath: "/company-jobs"
      preLoaderRoute: typeof appAuthCompanyJobsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/customer-club/": {
      id: "/(app)/_auth/customer-club/"
      path: "/customer-club"
      fullPath: "/customer-club"
      preLoaderRoute: typeof appAuthCustomerClubIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/customers/": {
      id: "/(app)/_auth/customers/"
      path: "/customers"
      fullPath: "/customers"
      preLoaderRoute: typeof appAuthCustomersIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/inspection-simulator/": {
      id: "/(app)/_auth/inspection-simulator/"
      path: "/inspection-simulator"
      fullPath: "/inspection-simulator"
      preLoaderRoute: typeof appAuthInspectionSimulatorIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/prestationer/": {
      id: "/(app)/_auth/prestationer/"
      path: "/prestationer"
      fullPath: "/prestationer"
      preLoaderRoute: typeof appAuthPrestationerIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/price-simulator/": {
      id: "/(app)/_auth/price-simulator/"
      path: "/price-simulator"
      fullPath: "/price-simulator"
      preLoaderRoute: typeof appAuthPriceSimulatorIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/products/": {
      id: "/(app)/_auth/products/"
      path: "/products"
      fullPath: "/products"
      preLoaderRoute: typeof appAuthProductsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/simulation-settings/": {
      id: "/(app)/_auth/simulation-settings/"
      path: "/simulation-settings"
      fullPath: "/simulation-settings"
      preLoaderRoute: typeof appAuthSimulationSettingsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/statistik/": {
      id: "/(app)/_auth/statistik/"
      path: "/statistik"
      fullPath: "/statistik"
      preLoaderRoute: typeof appAuthStatistikIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/tire-hotel/": {
      id: "/(app)/_auth/tire-hotel/"
      path: "/tire-hotel"
      fullPath: "/tire-hotel"
      preLoaderRoute: typeof appAuthTireHotelIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/trends/": {
      id: "/(app)/_auth/trends/"
      path: "/trends"
      fullPath: "/trends"
      preLoaderRoute: typeof appAuthTrendsIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/settings/communication/": {
      id: "/(app)/_auth/settings/communication/"
      path: "/"
      fullPath: "/settings/communication/"
      preLoaderRoute: typeof appAuthSettingsCommunicationIndexRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/companies/": {
      id: "/(app)/_auth/settings/companies/"
      path: "/"
      fullPath: "/settings/companies/"
      preLoaderRoute: typeof appAuthSettingsCompaniesIndexRouteImport
      parentRoute: typeof appAuthSettingsCompaniesRouteImport
    }
    "/(app)/_auth/bikes-for-sale/$bikeId/inspection": {
      id: "/(app)/_auth/bikes-for-sale/$bikeId/inspection"
      path: "/inspection"
      fullPath: "/bikes-for-sale/$bikeId/inspection"
      preLoaderRoute: typeof appAuthBikesForSaleBikeIdInspectionRouteImport
      parentRoute: typeof appAuthBikesForSaleBikeIdRouteImport
    }
    "/(app)/_auth/bikes-for-sale/$bikeId/listing": {
      id: "/(app)/_auth/bikes-for-sale/$bikeId/listing"
      path: "/listing"
      fullPath: "/bikes-for-sale/$bikeId/listing"
      preLoaderRoute: typeof appAuthBikesForSaleBikeIdListingRouteImport
      parentRoute: typeof appAuthBikesForSaleBikeIdRouteImport
    }
    "/(app)/_auth/event/$eventId/edit": {
      id: "/(app)/_auth/event/$eventId/edit"
      path: "/edit"
      fullPath: "/event/$eventId/edit"
      preLoaderRoute: typeof appAuthEventEventIdEditRouteImport
      parentRoute: typeof appAuthEventEventIdRouteImport
    }
    "/(app)/_auth/jobs/$jobId/inspection": {
      id: "/(app)/_auth/jobs/$jobId/inspection"
      path: "/inspection"
      fullPath: "/jobs/$jobId/inspection"
      preLoaderRoute: typeof appAuthJobsJobIdInspectionRouteImport
      parentRoute: typeof appAuthJobsJobIdRouteImport
    }
    "/(app)/_auth/jobs/$jobId/new-reception": {
      id: "/(app)/_auth/jobs/$jobId/new-reception"
      path: "/new-reception"
      fullPath: "/jobs/$jobId/new-reception"
      preLoaderRoute: typeof appAuthJobsJobIdNewReceptionRouteImport
      parentRoute: typeof appAuthJobsJobIdRouteImport
    }
    "/(app)/_auth/messages/customers/$customerId": {
      id: "/(app)/_auth/messages/customers/$customerId"
      path: "/customers/$customerId"
      fullPath: "/messages/customers/$customerId"
      preLoaderRoute: typeof appAuthMessagesCustomersCustomerIdRouteImport
      parentRoute: typeof appAuthMessagesRouteImport
    }
    "/(app)/_auth/settings/communication/booking": {
      id: "/(app)/_auth/settings/communication/booking"
      path: "/booking"
      fullPath: "/settings/communication/booking"
      preLoaderRoute: typeof appAuthSettingsCommunicationBookingRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/general": {
      id: "/(app)/_auth/settings/communication/general"
      path: "/general"
      fullPath: "/settings/communication/general"
      preLoaderRoute: typeof appAuthSettingsCommunicationGeneralRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/notifications": {
      id: "/(app)/_auth/settings/communication/notifications"
      path: "/notifications"
      fullPath: "/settings/communication/notifications"
      preLoaderRoute: typeof appAuthSettingsCommunicationNotificationsRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/pickup": {
      id: "/(app)/_auth/settings/communication/pickup"
      path: "/pickup"
      fullPath: "/settings/communication/pickup"
      preLoaderRoute: typeof appAuthSettingsCommunicationPickupRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/reception": {
      id: "/(app)/_auth/settings/communication/reception"
      path: "/reception"
      fullPath: "/settings/communication/reception"
      preLoaderRoute: typeof appAuthSettingsCommunicationReceptionRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/reminders": {
      id: "/(app)/_auth/settings/communication/reminders"
      path: "/reminders"
      fullPath: "/settings/communication/reminders"
      preLoaderRoute: typeof appAuthSettingsCommunicationRemindersRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/communication/templates": {
      id: "/(app)/_auth/settings/communication/templates"
      path: "/templates"
      fullPath: "/settings/communication/templates"
      preLoaderRoute: typeof appAuthSettingsCommunicationTemplatesRouteImport
      parentRoute: typeof appAuthSettingsCommunicationRouteImport
    }
    "/(app)/_auth/settings/companies/$companyId": {
      id: "/(app)/_auth/settings/companies/$companyId"
      path: "/$companyId"
      fullPath: "/settings/companies/$companyId"
      preLoaderRoute: typeof appAuthSettingsCompaniesCompanyIdRouteImport
      parentRoute: typeof appAuthSettingsCompaniesRouteImport
    }
    "/(app)/_auth/prestationer/$mechanicId/": {
      id: "/(app)/_auth/prestationer/$mechanicId/"
      path: "/prestationer/$mechanicId"
      fullPath: "/prestationer/$mechanicId"
      preLoaderRoute: typeof appAuthPrestationerMechanicIdIndexImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/bikes-for-sale/$bikeId/": {
      id: "/(app)/_auth/bikes-for-sale/$bikeId/"
      path: "/"
      fullPath: "/bikes-for-sale/$bikeId/"
      preLoaderRoute: typeof appAuthBikesForSaleBikeIdIndexLazyImport
      parentRoute: typeof appAuthBikesForSaleBikeIdRouteImport
    }
    "/(app)/_auth/customers/$customerId/": {
      id: "/(app)/_auth/customers/$customerId/"
      path: "/"
      fullPath: "/customers/$customerId/"
      preLoaderRoute: typeof appAuthCustomersCustomerIdIndexLazyImport
      parentRoute: typeof appAuthCustomersCustomerIdRouteImport
    }
    "/(app)/_auth/event/$eventId/": {
      id: "/(app)/_auth/event/$eventId/"
      path: "/"
      fullPath: "/event/$eventId/"
      preLoaderRoute: typeof appAuthEventEventIdIndexLazyImport
      parentRoute: typeof appAuthEventEventIdRouteImport
    }
    "/(app)/_auth/jobs/$jobId/": {
      id: "/(app)/_auth/jobs/$jobId/"
      path: "/"
      fullPath: "/jobs/$jobId/"
      preLoaderRoute: typeof appAuthJobsJobIdIndexLazyImport
      parentRoute: typeof appAuthJobsJobIdRouteImport
    }
    "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber": {
      id: "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber"
      path: "/companies/$companyId/fakturor/$invoiceNumber"
      fullPath: "/companies/$companyId/fakturor/$invoiceNumber"
      preLoaderRoute: typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/customers/$customerId/bikes/$bikeId": {
      id: "/(app)/_auth/customers/$customerId/bikes/$bikeId"
      path: "/bikes/$bikeId"
      fullPath: "/customers/$customerId/bikes/$bikeId"
      preLoaderRoute: typeof appAuthCustomersCustomerIdBikesBikeIdRouteImport
      parentRoute: typeof appAuthCustomersCustomerIdRouteImport
    }
    "/(app)/_auth/settings/companies/$companyId/": {
      id: "/(app)/_auth/settings/companies/$companyId/"
      path: "/"
      fullPath: "/settings/companies/$companyId/"
      preLoaderRoute: typeof appAuthSettingsCompaniesCompanyIdIndexLazyImport
      parentRoute: typeof appAuthSettingsCompaniesCompanyIdRouteImport
    }
    "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/": {
      id: "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/"
      path: "/"
      fullPath: "/companies/$companyId/fakturor/$invoiceNumber/"
      preLoaderRoute: typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyImport
      parentRoute: typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteImport
    }
  }
}

// Create and export the route tree

interface appAuthBikesForSaleBikeIdRouteRouteChildren {
  appAuthBikesForSaleBikeIdInspectionRouteRoute: typeof appAuthBikesForSaleBikeIdInspectionRouteRoute
  appAuthBikesForSaleBikeIdListingRouteRoute: typeof appAuthBikesForSaleBikeIdListingRouteRoute
  appAuthBikesForSaleBikeIdIndexLazyRoute: typeof appAuthBikesForSaleBikeIdIndexLazyRoute
}

const appAuthBikesForSaleBikeIdRouteRouteChildren: appAuthBikesForSaleBikeIdRouteRouteChildren =
  {
    appAuthBikesForSaleBikeIdInspectionRouteRoute:
      appAuthBikesForSaleBikeIdInspectionRouteRoute,
    appAuthBikesForSaleBikeIdListingRouteRoute:
      appAuthBikesForSaleBikeIdListingRouteRoute,
    appAuthBikesForSaleBikeIdIndexLazyRoute:
      appAuthBikesForSaleBikeIdIndexLazyRoute,
  }

const appAuthBikesForSaleBikeIdRouteRouteWithChildren =
  appAuthBikesForSaleBikeIdRouteRoute._addFileChildren(
    appAuthBikesForSaleBikeIdRouteRouteChildren,
  )

interface appAuthBikesForSaleRouteRouteChildren {
  appAuthBikesForSaleBikeIdRouteRoute: typeof appAuthBikesForSaleBikeIdRouteRouteWithChildren
  appAuthBikesForSaleInvoicesRouteRoute: typeof appAuthBikesForSaleInvoicesRouteRoute
  appAuthBikesForSaleNewRouteRoute: typeof appAuthBikesForSaleNewRouteRoute
  appAuthBikesForSaleIndexRoute: typeof appAuthBikesForSaleIndexRoute
}

const appAuthBikesForSaleRouteRouteChildren: appAuthBikesForSaleRouteRouteChildren =
  {
    appAuthBikesForSaleBikeIdRouteRoute:
      appAuthBikesForSaleBikeIdRouteRouteWithChildren,
    appAuthBikesForSaleInvoicesRouteRoute:
      appAuthBikesForSaleInvoicesRouteRoute,
    appAuthBikesForSaleNewRouteRoute: appAuthBikesForSaleNewRouteRoute,
    appAuthBikesForSaleIndexRoute: appAuthBikesForSaleIndexRoute,
  }

const appAuthBikesForSaleRouteRouteWithChildren =
  appAuthBikesForSaleRouteRoute._addFileChildren(
    appAuthBikesForSaleRouteRouteChildren,
  )

interface appAuthEventEventIdRouteRouteChildren {
  appAuthEventEventIdEditRouteRoute: typeof appAuthEventEventIdEditRouteRoute
  appAuthEventEventIdIndexLazyRoute: typeof appAuthEventEventIdIndexLazyRoute
}

const appAuthEventEventIdRouteRouteChildren: appAuthEventEventIdRouteRouteChildren =
  {
    appAuthEventEventIdEditRouteRoute: appAuthEventEventIdEditRouteRoute,
    appAuthEventEventIdIndexLazyRoute: appAuthEventEventIdIndexLazyRoute,
  }

const appAuthEventEventIdRouteRouteWithChildren =
  appAuthEventEventIdRouteRoute._addFileChildren(
    appAuthEventEventIdRouteRouteChildren,
  )

interface appAuthEventRouteRouteChildren {
  appAuthEventIndexRouteRoute: typeof appAuthEventIndexRouteRoute
  appAuthEventEventIdRouteRoute: typeof appAuthEventEventIdRouteRouteWithChildren
  appAuthEventCreateRouteRoute: typeof appAuthEventCreateRouteRoute
}

const appAuthEventRouteRouteChildren: appAuthEventRouteRouteChildren = {
  appAuthEventIndexRouteRoute: appAuthEventIndexRouteRoute,
  appAuthEventEventIdRouteRoute: appAuthEventEventIdRouteRouteWithChildren,
  appAuthEventCreateRouteRoute: appAuthEventCreateRouteRoute,
}

const appAuthEventRouteRouteWithChildren =
  appAuthEventRouteRoute._addFileChildren(appAuthEventRouteRouteChildren)

interface appAuthJobsJobIdRouteRouteChildren {
  appAuthJobsJobIdInspectionRouteRoute: typeof appAuthJobsJobIdInspectionRouteRoute
  appAuthJobsJobIdNewReceptionRouteRoute: typeof appAuthJobsJobIdNewReceptionRouteRoute
  appAuthJobsJobIdIndexLazyRoute: typeof appAuthJobsJobIdIndexLazyRoute
}

const appAuthJobsJobIdRouteRouteChildren: appAuthJobsJobIdRouteRouteChildren = {
  appAuthJobsJobIdInspectionRouteRoute: appAuthJobsJobIdInspectionRouteRoute,
  appAuthJobsJobIdNewReceptionRouteRoute:
    appAuthJobsJobIdNewReceptionRouteRoute,
  appAuthJobsJobIdIndexLazyRoute: appAuthJobsJobIdIndexLazyRoute,
}

const appAuthJobsJobIdRouteRouteWithChildren =
  appAuthJobsJobIdRouteRoute._addFileChildren(
    appAuthJobsJobIdRouteRouteChildren,
  )

interface appAuthJobsRouteRouteChildren {
  appAuthJobsIndexRouteRoute: typeof appAuthJobsIndexRouteRoute
  appAuthJobsJobIdRouteRoute: typeof appAuthJobsJobIdRouteRouteWithChildren
  appAuthJobsBookRouteRoute: typeof appAuthJobsBookRouteRoute
  appAuthJobsCreateRouteRoute: typeof appAuthJobsCreateRouteRoute
  appAuthJobsNewReceptionRouteRoute: typeof appAuthJobsNewReceptionRouteRoute
}

const appAuthJobsRouteRouteChildren: appAuthJobsRouteRouteChildren = {
  appAuthJobsIndexRouteRoute: appAuthJobsIndexRouteRoute,
  appAuthJobsJobIdRouteRoute: appAuthJobsJobIdRouteRouteWithChildren,
  appAuthJobsBookRouteRoute: appAuthJobsBookRouteRoute,
  appAuthJobsCreateRouteRoute: appAuthJobsCreateRouteRoute,
  appAuthJobsNewReceptionRouteRoute: appAuthJobsNewReceptionRouteRoute,
}

const appAuthJobsRouteRouteWithChildren =
  appAuthJobsRouteRoute._addFileChildren(appAuthJobsRouteRouteChildren)

interface appAuthMessagesRouteRouteChildren {
  appAuthMessagesJobIdRouteRoute: typeof appAuthMessagesJobIdRouteRoute
  appAuthMessagesCustomersCustomerIdRouteRoute: typeof appAuthMessagesCustomersCustomerIdRouteRoute
}

const appAuthMessagesRouteRouteChildren: appAuthMessagesRouteRouteChildren = {
  appAuthMessagesJobIdRouteRoute: appAuthMessagesJobIdRouteRoute,
  appAuthMessagesCustomersCustomerIdRouteRoute:
    appAuthMessagesCustomersCustomerIdRouteRoute,
}

const appAuthMessagesRouteRouteWithChildren =
  appAuthMessagesRouteRoute._addFileChildren(appAuthMessagesRouteRouteChildren)

interface appAuthSettingsCommunicationRouteRouteChildren {
  appAuthSettingsCommunicationIndexRouteRoute: typeof appAuthSettingsCommunicationIndexRouteRoute
  appAuthSettingsCommunicationBookingRouteRoute: typeof appAuthSettingsCommunicationBookingRouteRoute
  appAuthSettingsCommunicationGeneralRouteRoute: typeof appAuthSettingsCommunicationGeneralRouteRoute
  appAuthSettingsCommunicationNotificationsRouteRoute: typeof appAuthSettingsCommunicationNotificationsRouteRoute
  appAuthSettingsCommunicationPickupRouteRoute: typeof appAuthSettingsCommunicationPickupRouteRoute
  appAuthSettingsCommunicationReceptionRouteRoute: typeof appAuthSettingsCommunicationReceptionRouteRoute
  appAuthSettingsCommunicationRemindersRouteRoute: typeof appAuthSettingsCommunicationRemindersRouteRoute
  appAuthSettingsCommunicationTemplatesRouteRoute: typeof appAuthSettingsCommunicationTemplatesRouteRoute
}

const appAuthSettingsCommunicationRouteRouteChildren: appAuthSettingsCommunicationRouteRouteChildren =
  {
    appAuthSettingsCommunicationIndexRouteRoute:
      appAuthSettingsCommunicationIndexRouteRoute,
    appAuthSettingsCommunicationBookingRouteRoute:
      appAuthSettingsCommunicationBookingRouteRoute,
    appAuthSettingsCommunicationGeneralRouteRoute:
      appAuthSettingsCommunicationGeneralRouteRoute,
    appAuthSettingsCommunicationNotificationsRouteRoute:
      appAuthSettingsCommunicationNotificationsRouteRoute,
    appAuthSettingsCommunicationPickupRouteRoute:
      appAuthSettingsCommunicationPickupRouteRoute,
    appAuthSettingsCommunicationReceptionRouteRoute:
      appAuthSettingsCommunicationReceptionRouteRoute,
    appAuthSettingsCommunicationRemindersRouteRoute:
      appAuthSettingsCommunicationRemindersRouteRoute,
    appAuthSettingsCommunicationTemplatesRouteRoute:
      appAuthSettingsCommunicationTemplatesRouteRoute,
  }

const appAuthSettingsCommunicationRouteRouteWithChildren =
  appAuthSettingsCommunicationRouteRoute._addFileChildren(
    appAuthSettingsCommunicationRouteRouteChildren,
  )

interface appAuthSettingsCompaniesCompanyIdRouteRouteChildren {
  appAuthSettingsCompaniesCompanyIdIndexLazyRoute: typeof appAuthSettingsCompaniesCompanyIdIndexLazyRoute
}

const appAuthSettingsCompaniesCompanyIdRouteRouteChildren: appAuthSettingsCompaniesCompanyIdRouteRouteChildren =
  {
    appAuthSettingsCompaniesCompanyIdIndexLazyRoute:
      appAuthSettingsCompaniesCompanyIdIndexLazyRoute,
  }

const appAuthSettingsCompaniesCompanyIdRouteRouteWithChildren =
  appAuthSettingsCompaniesCompanyIdRouteRoute._addFileChildren(
    appAuthSettingsCompaniesCompanyIdRouteRouteChildren,
  )

interface appAuthSettingsCompaniesRouteRouteChildren {
  appAuthSettingsCompaniesIndexRouteRoute: typeof appAuthSettingsCompaniesIndexRouteRoute
  appAuthSettingsCompaniesCompanyIdRouteRoute: typeof appAuthSettingsCompaniesCompanyIdRouteRouteWithChildren
}

const appAuthSettingsCompaniesRouteRouteChildren: appAuthSettingsCompaniesRouteRouteChildren =
  {
    appAuthSettingsCompaniesIndexRouteRoute:
      appAuthSettingsCompaniesIndexRouteRoute,
    appAuthSettingsCompaniesCompanyIdRouteRoute:
      appAuthSettingsCompaniesCompanyIdRouteRouteWithChildren,
  }

const appAuthSettingsCompaniesRouteRouteWithChildren =
  appAuthSettingsCompaniesRouteRoute._addFileChildren(
    appAuthSettingsCompaniesRouteRouteChildren,
  )

interface appAuthSettingsRouteRouteChildren {
  appAuthSettingsIndexRouteRoute: typeof appAuthSettingsIndexRouteRoute
  appAuthSettingsActionVisibilityRouteRoute: typeof appAuthSettingsActionVisibilityRouteRoute
  appAuthSettingsBikesForSaleRouteRoute: typeof appAuthSettingsBikesForSaleRouteRoute
  appAuthSettingsBookableSlotsRouteRoute: typeof appAuthSettingsBookableSlotsRouteRoute
  appAuthSettingsBookingFormTextRouteRoute: typeof appAuthSettingsBookingFormTextRouteRoute
  appAuthSettingsBookingOrderRouteRoute: typeof appAuthSettingsBookingOrderRouteRoute
  appAuthSettingsCommunicationRouteRoute: typeof appAuthSettingsCommunicationRouteRouteWithChildren
  appAuthSettingsCompaniesRouteRoute: typeof appAuthSettingsCompaniesRouteRouteWithChildren
  appAuthSettingsCustomSectionsRouteRoute: typeof appAuthSettingsCustomSectionsRouteRoute
  appAuthSettingsDamperServiceRouteRoute: typeof appAuthSettingsDamperServiceRouteRoute
  appAuthSettingsEmergencyServiceRouteRoute: typeof appAuthSettingsEmergencyServiceRouteRoute
  appAuthSettingsFeeRouteRoute: typeof appAuthSettingsFeeRouteRoute
  appAuthSettingsKassakopplingRouteRoute: typeof appAuthSettingsKassakopplingRouteRoute
  appAuthSettingsLabelsRouteRoute: typeof appAuthSettingsLabelsRouteRoute
  appAuthSettingsLeadTimeRouteRoute: typeof appAuthSettingsLeadTimeRouteRoute
  appAuthSettingsPartsRouteRoute: typeof appAuthSettingsPartsRouteRoute
  appAuthSettingsPriceListRouteRoute: typeof appAuthSettingsPriceListRouteRoute
  appAuthSettingsPricesRouteRoute: typeof appAuthSettingsPricesRouteRoute
  appAuthSettingsReceptionRouteRoute: typeof appAuthSettingsReceptionRouteRoute
  appAuthSettingsReviewsRouteRoute: typeof appAuthSettingsReviewsRouteRoute
  appAuthSettingsServicePackagesRouteRoute: typeof appAuthSettingsServicePackagesRouteRoute
  appAuthSettingsServiceRemindersRouteRoute: typeof appAuthSettingsServiceRemindersRouteRoute
  appAuthSettingsServicesRouteRoute: typeof appAuthSettingsServicesRouteRoute
  appAuthSettingsStorageLocationsRouteRoute: typeof appAuthSettingsStorageLocationsRouteRoute
  appAuthSettingsTireHotelRouteRoute: typeof appAuthSettingsTireHotelRouteRoute
  appAuthSettingsUserAccountsRouteRoute: typeof appAuthSettingsUserAccountsRouteRoute
  appAuthSettingsWashRouteRoute: typeof appAuthSettingsWashRouteRoute
  appAuthSettingsWidgetCustomizationRouteRoute: typeof appAuthSettingsWidgetCustomizationRouteRoute
  appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute: typeof appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute
  appAuthSettingsInspectionOrderRouteLazyRoute: typeof appAuthSettingsInspectionOrderRouteLazyRoute
}

const appAuthSettingsRouteRouteChildren: appAuthSettingsRouteRouteChildren = {
  appAuthSettingsIndexRouteRoute: appAuthSettingsIndexRouteRoute,
  appAuthSettingsActionVisibilityRouteRoute:
    appAuthSettingsActionVisibilityRouteRoute,
  appAuthSettingsBikesForSaleRouteRoute: appAuthSettingsBikesForSaleRouteRoute,
  appAuthSettingsBookableSlotsRouteRoute:
    appAuthSettingsBookableSlotsRouteRoute,
  appAuthSettingsBookingFormTextRouteRoute:
    appAuthSettingsBookingFormTextRouteRoute,
  appAuthSettingsBookingOrderRouteRoute: appAuthSettingsBookingOrderRouteRoute,
  appAuthSettingsCommunicationRouteRoute:
    appAuthSettingsCommunicationRouteRouteWithChildren,
  appAuthSettingsCompaniesRouteRoute:
    appAuthSettingsCompaniesRouteRouteWithChildren,
  appAuthSettingsCustomSectionsRouteRoute:
    appAuthSettingsCustomSectionsRouteRoute,
  appAuthSettingsDamperServiceRouteRoute:
    appAuthSettingsDamperServiceRouteRoute,
  appAuthSettingsEmergencyServiceRouteRoute:
    appAuthSettingsEmergencyServiceRouteRoute,
  appAuthSettingsFeeRouteRoute: appAuthSettingsFeeRouteRoute,
  appAuthSettingsKassakopplingRouteRoute:
    appAuthSettingsKassakopplingRouteRoute,
  appAuthSettingsLabelsRouteRoute: appAuthSettingsLabelsRouteRoute,
  appAuthSettingsLeadTimeRouteRoute: appAuthSettingsLeadTimeRouteRoute,
  appAuthSettingsPartsRouteRoute: appAuthSettingsPartsRouteRoute,
  appAuthSettingsPriceListRouteRoute: appAuthSettingsPriceListRouteRoute,
  appAuthSettingsPricesRouteRoute: appAuthSettingsPricesRouteRoute,
  appAuthSettingsReceptionRouteRoute: appAuthSettingsReceptionRouteRoute,
  appAuthSettingsReviewsRouteRoute: appAuthSettingsReviewsRouteRoute,
  appAuthSettingsServicePackagesRouteRoute:
    appAuthSettingsServicePackagesRouteRoute,
  appAuthSettingsServiceRemindersRouteRoute:
    appAuthSettingsServiceRemindersRouteRoute,
  appAuthSettingsServicesRouteRoute: appAuthSettingsServicesRouteRoute,
  appAuthSettingsStorageLocationsRouteRoute:
    appAuthSettingsStorageLocationsRouteRoute,
  appAuthSettingsTireHotelRouteRoute: appAuthSettingsTireHotelRouteRoute,
  appAuthSettingsUserAccountsRouteRoute: appAuthSettingsUserAccountsRouteRoute,
  appAuthSettingsWashRouteRoute: appAuthSettingsWashRouteRoute,
  appAuthSettingsWidgetCustomizationRouteRoute:
    appAuthSettingsWidgetCustomizationRouteRoute,
  appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute:
    appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute,
  appAuthSettingsInspectionOrderRouteLazyRoute:
    appAuthSettingsInspectionOrderRouteLazyRoute,
}

const appAuthSettingsRouteRouteWithChildren =
  appAuthSettingsRouteRoute._addFileChildren(appAuthSettingsRouteRouteChildren)

interface appAuthCustomersCustomerIdRouteRouteChildren {
  appAuthCustomersCustomerIdIndexLazyRoute: typeof appAuthCustomersCustomerIdIndexLazyRoute
  appAuthCustomersCustomerIdBikesBikeIdRouteRoute: typeof appAuthCustomersCustomerIdBikesBikeIdRouteRoute
}

const appAuthCustomersCustomerIdRouteRouteChildren: appAuthCustomersCustomerIdRouteRouteChildren =
  {
    appAuthCustomersCustomerIdIndexLazyRoute:
      appAuthCustomersCustomerIdIndexLazyRoute,
    appAuthCustomersCustomerIdBikesBikeIdRouteRoute:
      appAuthCustomersCustomerIdBikesBikeIdRouteRoute,
  }

const appAuthCustomersCustomerIdRouteRouteWithChildren =
  appAuthCustomersCustomerIdRouteRoute._addFileChildren(
    appAuthCustomersCustomerIdRouteRouteChildren,
  )

interface appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteChildren {
  appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute: typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute
}

const appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteChildren: appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteChildren =
  {
    appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute:
      appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute,
  }

const appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteWithChildren =
  appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRoute._addFileChildren(
    appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteChildren,
  )

interface appAuthRouteChildren {
  appAuthBikesForSaleRouteRoute: typeof appAuthBikesForSaleRouteRouteWithChildren
  appAuthBookingQrCodeRouteRoute: typeof appAuthBookingQrCodeRouteRoute
  appAuthCalendarRouteRoute: typeof appAuthCalendarRouteRoute
  appAuthCheckInRouteRoute: typeof appAuthCheckInRouteRoute
  appAuthEventRouteRoute: typeof appAuthEventRouteRouteWithChildren
  appAuthJobsRouteRoute: typeof appAuthJobsRouteRouteWithChildren
  appAuthJobsNewRouteRoute: typeof appAuthJobsNewRouteRoute
  appAuthJuloUpdatesRouteRoute: typeof appAuthJuloUpdatesRouteRoute
  appAuthMessagesRouteRoute: typeof appAuthMessagesRouteRouteWithChildren
  appAuthOnboardingRouteRoute: typeof appAuthOnboardingRouteRoute
  appAuthRabattkoderRouteRoute: typeof appAuthRabattkoderRouteRoute
  appAuthReviewsRouteRoute: typeof appAuthReviewsRouteRoute
  appAuthSettingsRouteRoute: typeof appAuthSettingsRouteRouteWithChildren
  appAuthSupportChatRouteRoute: typeof appAuthSupportChatRouteRoute
  appAuthIndexRoute: typeof appAuthIndexRoute
  appAuthCustomersCustomerIdRouteRoute: typeof appAuthCustomersCustomerIdRouteRouteWithChildren
  appAuthTireHotelTireStorageIdRouteRoute: typeof appAuthTireHotelTireStorageIdRouteRoute
  appAuthAlfredImpactIndexRoute: typeof appAuthAlfredImpactIndexRoute
  appAuthAllJobsIndexRoute: typeof appAuthAllJobsIndexRoute
  appAuthAutomaticEmailsIndexRoute: typeof appAuthAutomaticEmailsIndexRoute
  appAuthCompanyJobsIndexRoute: typeof appAuthCompanyJobsIndexRoute
  appAuthCustomerClubIndexRoute: typeof appAuthCustomerClubIndexRoute
  appAuthCustomersIndexRoute: typeof appAuthCustomersIndexRoute
  appAuthInspectionSimulatorIndexRoute: typeof appAuthInspectionSimulatorIndexRoute
  appAuthPrestationerIndexRoute: typeof appAuthPrestationerIndexRoute
  appAuthPriceSimulatorIndexRoute: typeof appAuthPriceSimulatorIndexRoute
  appAuthProductsIndexRoute: typeof appAuthProductsIndexRoute
  appAuthSimulationSettingsIndexRoute: typeof appAuthSimulationSettingsIndexRoute
  appAuthStatistikIndexRoute: typeof appAuthStatistikIndexRoute
  appAuthTireHotelIndexRoute: typeof appAuthTireHotelIndexRoute
  appAuthTrendsIndexRoute: typeof appAuthTrendsIndexRoute
  appAuthPrestationerMechanicIdIndexRoute: typeof appAuthPrestationerMechanicIdIndexRoute
  appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRoute: typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteWithChildren
}

const appAuthRouteChildren: appAuthRouteChildren = {
  appAuthBikesForSaleRouteRoute: appAuthBikesForSaleRouteRouteWithChildren,
  appAuthBookingQrCodeRouteRoute: appAuthBookingQrCodeRouteRoute,
  appAuthCalendarRouteRoute: appAuthCalendarRouteRoute,
  appAuthCheckInRouteRoute: appAuthCheckInRouteRoute,
  appAuthEventRouteRoute: appAuthEventRouteRouteWithChildren,
  appAuthJobsRouteRoute: appAuthJobsRouteRouteWithChildren,
  appAuthJobsNewRouteRoute: appAuthJobsNewRouteRoute,
  appAuthJuloUpdatesRouteRoute: appAuthJuloUpdatesRouteRoute,
  appAuthMessagesRouteRoute: appAuthMessagesRouteRouteWithChildren,
  appAuthOnboardingRouteRoute: appAuthOnboardingRouteRoute,
  appAuthRabattkoderRouteRoute: appAuthRabattkoderRouteRoute,
  appAuthReviewsRouteRoute: appAuthReviewsRouteRoute,
  appAuthSettingsRouteRoute: appAuthSettingsRouteRouteWithChildren,
  appAuthSupportChatRouteRoute: appAuthSupportChatRouteRoute,
  appAuthIndexRoute: appAuthIndexRoute,
  appAuthCustomersCustomerIdRouteRoute:
    appAuthCustomersCustomerIdRouteRouteWithChildren,
  appAuthTireHotelTireStorageIdRouteRoute:
    appAuthTireHotelTireStorageIdRouteRoute,
  appAuthAlfredImpactIndexRoute: appAuthAlfredImpactIndexRoute,
  appAuthAllJobsIndexRoute: appAuthAllJobsIndexRoute,
  appAuthAutomaticEmailsIndexRoute: appAuthAutomaticEmailsIndexRoute,
  appAuthCompanyJobsIndexRoute: appAuthCompanyJobsIndexRoute,
  appAuthCustomerClubIndexRoute: appAuthCustomerClubIndexRoute,
  appAuthCustomersIndexRoute: appAuthCustomersIndexRoute,
  appAuthInspectionSimulatorIndexRoute: appAuthInspectionSimulatorIndexRoute,
  appAuthPrestationerIndexRoute: appAuthPrestationerIndexRoute,
  appAuthPriceSimulatorIndexRoute: appAuthPriceSimulatorIndexRoute,
  appAuthProductsIndexRoute: appAuthProductsIndexRoute,
  appAuthSimulationSettingsIndexRoute: appAuthSimulationSettingsIndexRoute,
  appAuthStatistikIndexRoute: appAuthStatistikIndexRoute,
  appAuthTireHotelIndexRoute: appAuthTireHotelIndexRoute,
  appAuthTrendsIndexRoute: appAuthTrendsIndexRoute,
  appAuthPrestationerMechanicIdIndexRoute:
    appAuthPrestationerMechanicIdIndexRoute,
  appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRoute:
    appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteWithChildren,
}

const appAuthRouteWithChildren =
  appAuthRoute._addFileChildren(appAuthRouteChildren)

interface appRouteChildren {
  appAuthRoute: typeof appAuthRouteWithChildren
}

const appRouteChildren: appRouteChildren = {
  appAuthRoute: appAuthRouteWithChildren,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

export interface FileRoutesByFullPath {
  "/login": typeof authLoginRouteRoute
  "/reset-password": typeof authResetPasswordRouteRoute
  "/set-new-password": typeof authSetNewPasswordRouteRoute
  "/": typeof appAuthIndexRoute
  "/bikes-for-sale": typeof appAuthBikesForSaleRouteRouteWithChildren
  "/booking-qr-code": typeof appAuthBookingQrCodeRouteRoute
  "/calendar": typeof appAuthCalendarRouteRoute
  "/check-in": typeof appAuthCheckInRouteRoute
  "/event": typeof appAuthEventRouteRouteWithChildren
  "/jobs": typeof appAuthJobsRouteRouteWithChildren
  "/jobs-new": typeof appAuthJobsNewRouteRoute
  "/julo-updates": typeof appAuthJuloUpdatesRouteRoute
  "/messages": typeof appAuthMessagesRouteRouteWithChildren
  "/onboarding": typeof appAuthOnboardingRouteRoute
  "/rabattkoder": typeof appAuthRabattkoderRouteRoute
  "/reviews": typeof appAuthReviewsRouteRoute
  "/settings": typeof appAuthSettingsRouteRouteWithChildren
  "/support-chat": typeof appAuthSupportChatRouteRoute
  "/event/": typeof appAuthEventIndexRouteRoute
  "/jobs/": typeof appAuthJobsIndexRouteRoute
  "/settings/": typeof appAuthSettingsIndexRouteRoute
  "/bikes-for-sale/$bikeId": typeof appAuthBikesForSaleBikeIdRouteRouteWithChildren
  "/bikes-for-sale/invoices": typeof appAuthBikesForSaleInvoicesRouteRoute
  "/bikes-for-sale/new": typeof appAuthBikesForSaleNewRouteRoute
  "/customers/$customerId": typeof appAuthCustomersCustomerIdRouteRouteWithChildren
  "/event/$eventId": typeof appAuthEventEventIdRouteRouteWithChildren
  "/event/create": typeof appAuthEventCreateRouteRoute
  "/jobs/$jobId": typeof appAuthJobsJobIdRouteRouteWithChildren
  "/jobs/book": typeof appAuthJobsBookRouteRoute
  "/jobs/create": typeof appAuthJobsCreateRouteRoute
  "/jobs/new-reception": typeof appAuthJobsNewReceptionRouteRoute
  "/messages/$jobId": typeof appAuthMessagesJobIdRouteRoute
  "/settings/action-visibility": typeof appAuthSettingsActionVisibilityRouteRoute
  "/settings/bikes-for-sale": typeof appAuthSettingsBikesForSaleRouteRoute
  "/settings/bookable-slots": typeof appAuthSettingsBookableSlotsRouteRoute
  "/settings/booking-form-text": typeof appAuthSettingsBookingFormTextRouteRoute
  "/settings/booking-order": typeof appAuthSettingsBookingOrderRouteRoute
  "/settings/communication": typeof appAuthSettingsCommunicationRouteRouteWithChildren
  "/settings/companies": typeof appAuthSettingsCompaniesRouteRouteWithChildren
  "/settings/custom-sections": typeof appAuthSettingsCustomSectionsRouteRoute
  "/settings/damper-service": typeof appAuthSettingsDamperServiceRouteRoute
  "/settings/emergency-service": typeof appAuthSettingsEmergencyServiceRouteRoute
  "/settings/fee": typeof appAuthSettingsFeeRouteRoute
  "/settings/kassakoppling": typeof appAuthSettingsKassakopplingRouteRoute
  "/settings/labels": typeof appAuthSettingsLabelsRouteRoute
  "/settings/lead-time": typeof appAuthSettingsLeadTimeRouteRoute
  "/settings/parts": typeof appAuthSettingsPartsRouteRoute
  "/settings/price-list": typeof appAuthSettingsPriceListRouteRoute
  "/settings/prices": typeof appAuthSettingsPricesRouteRoute
  "/settings/reception": typeof appAuthSettingsReceptionRouteRoute
  "/settings/reviews": typeof appAuthSettingsReviewsRouteRoute
  "/settings/service-packages": typeof appAuthSettingsServicePackagesRouteRoute
  "/settings/service-reminders": typeof appAuthSettingsServiceRemindersRouteRoute
  "/settings/services": typeof appAuthSettingsServicesRouteRoute
  "/settings/storage-locations": typeof appAuthSettingsStorageLocationsRouteRoute
  "/settings/tire-hotel": typeof appAuthSettingsTireHotelRouteRoute
  "/settings/user-accounts": typeof appAuthSettingsUserAccountsRouteRoute
  "/settings/wash": typeof appAuthSettingsWashRouteRoute
  "/settings/widget-customization": typeof appAuthSettingsWidgetCustomizationRouteRoute
  "/tire-hotel/$tireStorageId": typeof appAuthTireHotelTireStorageIdRouteRoute
  "/settings/booking-rules-and-opening-hours": typeof appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute
  "/settings/inspection-order": typeof appAuthSettingsInspectionOrderRouteLazyRoute
  "/alfred-impact": typeof appAuthAlfredImpactIndexRoute
  "/all-jobs": typeof appAuthAllJobsIndexRoute
  "/automatic-emails": typeof appAuthAutomaticEmailsIndexRoute
  "/bikes-for-sale/": typeof appAuthBikesForSaleIndexRoute
  "/company-jobs": typeof appAuthCompanyJobsIndexRoute
  "/customer-club": typeof appAuthCustomerClubIndexRoute
  "/customers": typeof appAuthCustomersIndexRoute
  "/inspection-simulator": typeof appAuthInspectionSimulatorIndexRoute
  "/prestationer": typeof appAuthPrestationerIndexRoute
  "/price-simulator": typeof appAuthPriceSimulatorIndexRoute
  "/products": typeof appAuthProductsIndexRoute
  "/simulation-settings": typeof appAuthSimulationSettingsIndexRoute
  "/statistik": typeof appAuthStatistikIndexRoute
  "/tire-hotel": typeof appAuthTireHotelIndexRoute
  "/trends": typeof appAuthTrendsIndexRoute
  "/settings/communication/": typeof appAuthSettingsCommunicationIndexRouteRoute
  "/settings/companies/": typeof appAuthSettingsCompaniesIndexRouteRoute
  "/bikes-for-sale/$bikeId/inspection": typeof appAuthBikesForSaleBikeIdInspectionRouteRoute
  "/bikes-for-sale/$bikeId/listing": typeof appAuthBikesForSaleBikeIdListingRouteRoute
  "/event/$eventId/edit": typeof appAuthEventEventIdEditRouteRoute
  "/jobs/$jobId/inspection": typeof appAuthJobsJobIdInspectionRouteRoute
  "/jobs/$jobId/new-reception": typeof appAuthJobsJobIdNewReceptionRouteRoute
  "/messages/customers/$customerId": typeof appAuthMessagesCustomersCustomerIdRouteRoute
  "/settings/communication/booking": typeof appAuthSettingsCommunicationBookingRouteRoute
  "/settings/communication/general": typeof appAuthSettingsCommunicationGeneralRouteRoute
  "/settings/communication/notifications": typeof appAuthSettingsCommunicationNotificationsRouteRoute
  "/settings/communication/pickup": typeof appAuthSettingsCommunicationPickupRouteRoute
  "/settings/communication/reception": typeof appAuthSettingsCommunicationReceptionRouteRoute
  "/settings/communication/reminders": typeof appAuthSettingsCommunicationRemindersRouteRoute
  "/settings/communication/templates": typeof appAuthSettingsCommunicationTemplatesRouteRoute
  "/settings/companies/$companyId": typeof appAuthSettingsCompaniesCompanyIdRouteRouteWithChildren
  "/prestationer/$mechanicId": typeof appAuthPrestationerMechanicIdIndexRoute
  "/bikes-for-sale/$bikeId/": typeof appAuthBikesForSaleBikeIdIndexLazyRoute
  "/customers/$customerId/": typeof appAuthCustomersCustomerIdIndexLazyRoute
  "/event/$eventId/": typeof appAuthEventEventIdIndexLazyRoute
  "/jobs/$jobId/": typeof appAuthJobsJobIdIndexLazyRoute
  "/companies/$companyId/fakturor/$invoiceNumber": typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteWithChildren
  "/customers/$customerId/bikes/$bikeId": typeof appAuthCustomersCustomerIdBikesBikeIdRouteRoute
  "/settings/companies/$companyId/": typeof appAuthSettingsCompaniesCompanyIdIndexLazyRoute
  "/companies/$companyId/fakturor/$invoiceNumber/": typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute
}

export interface FileRoutesByTo {
  "/login": typeof authLoginRouteRoute
  "/reset-password": typeof authResetPasswordRouteRoute
  "/set-new-password": typeof authSetNewPasswordRouteRoute
  "/booking-qr-code": typeof appAuthBookingQrCodeRouteRoute
  "/calendar": typeof appAuthCalendarRouteRoute
  "/check-in": typeof appAuthCheckInRouteRoute
  "/jobs-new": typeof appAuthJobsNewRouteRoute
  "/julo-updates": typeof appAuthJuloUpdatesRouteRoute
  "/messages": typeof appAuthMessagesRouteRouteWithChildren
  "/onboarding": typeof appAuthOnboardingRouteRoute
  "/rabattkoder": typeof appAuthRabattkoderRouteRoute
  "/reviews": typeof appAuthReviewsRouteRoute
  "/support-chat": typeof appAuthSupportChatRouteRoute
  "/": typeof appAuthIndexRoute
  "/event": typeof appAuthEventIndexRouteRoute
  "/jobs": typeof appAuthJobsIndexRouteRoute
  "/settings": typeof appAuthSettingsIndexRouteRoute
  "/bikes-for-sale/invoices": typeof appAuthBikesForSaleInvoicesRouteRoute
  "/bikes-for-sale/new": typeof appAuthBikesForSaleNewRouteRoute
  "/event/create": typeof appAuthEventCreateRouteRoute
  "/jobs/book": typeof appAuthJobsBookRouteRoute
  "/jobs/create": typeof appAuthJobsCreateRouteRoute
  "/jobs/new-reception": typeof appAuthJobsNewReceptionRouteRoute
  "/messages/$jobId": typeof appAuthMessagesJobIdRouteRoute
  "/settings/action-visibility": typeof appAuthSettingsActionVisibilityRouteRoute
  "/settings/bikes-for-sale": typeof appAuthSettingsBikesForSaleRouteRoute
  "/settings/bookable-slots": typeof appAuthSettingsBookableSlotsRouteRoute
  "/settings/booking-form-text": typeof appAuthSettingsBookingFormTextRouteRoute
  "/settings/booking-order": typeof appAuthSettingsBookingOrderRouteRoute
  "/settings/custom-sections": typeof appAuthSettingsCustomSectionsRouteRoute
  "/settings/damper-service": typeof appAuthSettingsDamperServiceRouteRoute
  "/settings/emergency-service": typeof appAuthSettingsEmergencyServiceRouteRoute
  "/settings/fee": typeof appAuthSettingsFeeRouteRoute
  "/settings/kassakoppling": typeof appAuthSettingsKassakopplingRouteRoute
  "/settings/labels": typeof appAuthSettingsLabelsRouteRoute
  "/settings/lead-time": typeof appAuthSettingsLeadTimeRouteRoute
  "/settings/parts": typeof appAuthSettingsPartsRouteRoute
  "/settings/price-list": typeof appAuthSettingsPriceListRouteRoute
  "/settings/prices": typeof appAuthSettingsPricesRouteRoute
  "/settings/reception": typeof appAuthSettingsReceptionRouteRoute
  "/settings/reviews": typeof appAuthSettingsReviewsRouteRoute
  "/settings/service-packages": typeof appAuthSettingsServicePackagesRouteRoute
  "/settings/service-reminders": typeof appAuthSettingsServiceRemindersRouteRoute
  "/settings/services": typeof appAuthSettingsServicesRouteRoute
  "/settings/storage-locations": typeof appAuthSettingsStorageLocationsRouteRoute
  "/settings/tire-hotel": typeof appAuthSettingsTireHotelRouteRoute
  "/settings/user-accounts": typeof appAuthSettingsUserAccountsRouteRoute
  "/settings/wash": typeof appAuthSettingsWashRouteRoute
  "/settings/widget-customization": typeof appAuthSettingsWidgetCustomizationRouteRoute
  "/tire-hotel/$tireStorageId": typeof appAuthTireHotelTireStorageIdRouteRoute
  "/settings/booking-rules-and-opening-hours": typeof appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute
  "/settings/inspection-order": typeof appAuthSettingsInspectionOrderRouteLazyRoute
  "/alfred-impact": typeof appAuthAlfredImpactIndexRoute
  "/all-jobs": typeof appAuthAllJobsIndexRoute
  "/automatic-emails": typeof appAuthAutomaticEmailsIndexRoute
  "/bikes-for-sale": typeof appAuthBikesForSaleIndexRoute
  "/company-jobs": typeof appAuthCompanyJobsIndexRoute
  "/customer-club": typeof appAuthCustomerClubIndexRoute
  "/customers": typeof appAuthCustomersIndexRoute
  "/inspection-simulator": typeof appAuthInspectionSimulatorIndexRoute
  "/prestationer": typeof appAuthPrestationerIndexRoute
  "/price-simulator": typeof appAuthPriceSimulatorIndexRoute
  "/products": typeof appAuthProductsIndexRoute
  "/simulation-settings": typeof appAuthSimulationSettingsIndexRoute
  "/statistik": typeof appAuthStatistikIndexRoute
  "/tire-hotel": typeof appAuthTireHotelIndexRoute
  "/trends": typeof appAuthTrendsIndexRoute
  "/settings/communication": typeof appAuthSettingsCommunicationIndexRouteRoute
  "/settings/companies": typeof appAuthSettingsCompaniesIndexRouteRoute
  "/bikes-for-sale/$bikeId/inspection": typeof appAuthBikesForSaleBikeIdInspectionRouteRoute
  "/bikes-for-sale/$bikeId/listing": typeof appAuthBikesForSaleBikeIdListingRouteRoute
  "/event/$eventId/edit": typeof appAuthEventEventIdEditRouteRoute
  "/jobs/$jobId/inspection": typeof appAuthJobsJobIdInspectionRouteRoute
  "/jobs/$jobId/new-reception": typeof appAuthJobsJobIdNewReceptionRouteRoute
  "/messages/customers/$customerId": typeof appAuthMessagesCustomersCustomerIdRouteRoute
  "/settings/communication/booking": typeof appAuthSettingsCommunicationBookingRouteRoute
  "/settings/communication/general": typeof appAuthSettingsCommunicationGeneralRouteRoute
  "/settings/communication/notifications": typeof appAuthSettingsCommunicationNotificationsRouteRoute
  "/settings/communication/pickup": typeof appAuthSettingsCommunicationPickupRouteRoute
  "/settings/communication/reception": typeof appAuthSettingsCommunicationReceptionRouteRoute
  "/settings/communication/reminders": typeof appAuthSettingsCommunicationRemindersRouteRoute
  "/settings/communication/templates": typeof appAuthSettingsCommunicationTemplatesRouteRoute
  "/prestationer/$mechanicId": typeof appAuthPrestationerMechanicIdIndexRoute
  "/bikes-for-sale/$bikeId": typeof appAuthBikesForSaleBikeIdIndexLazyRoute
  "/customers/$customerId": typeof appAuthCustomersCustomerIdIndexLazyRoute
  "/event/$eventId": typeof appAuthEventEventIdIndexLazyRoute
  "/jobs/$jobId": typeof appAuthJobsJobIdIndexLazyRoute
  "/customers/$customerId/bikes/$bikeId": typeof appAuthCustomersCustomerIdBikesBikeIdRouteRoute
  "/settings/companies/$companyId": typeof appAuthSettingsCompaniesCompanyIdIndexLazyRoute
  "/companies/$companyId/fakturor/$invoiceNumber": typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/(auth)/login": typeof authLoginRouteRoute
  "/(auth)/reset-password": typeof authResetPasswordRouteRoute
  "/(auth)/set-new-password": typeof authSetNewPasswordRouteRoute
  "/(app)": typeof appRouteWithChildren
  "/(app)/_auth": typeof appAuthRouteWithChildren
  "/(app)/_auth/bikes-for-sale": typeof appAuthBikesForSaleRouteRouteWithChildren
  "/(app)/_auth/booking-qr-code": typeof appAuthBookingQrCodeRouteRoute
  "/(app)/_auth/calendar": typeof appAuthCalendarRouteRoute
  "/(app)/_auth/check-in": typeof appAuthCheckInRouteRoute
  "/(app)/_auth/event": typeof appAuthEventRouteRouteWithChildren
  "/(app)/_auth/jobs": typeof appAuthJobsRouteRouteWithChildren
  "/(app)/_auth/jobs-new": typeof appAuthJobsNewRouteRoute
  "/(app)/_auth/julo-updates": typeof appAuthJuloUpdatesRouteRoute
  "/(app)/_auth/messages": typeof appAuthMessagesRouteRouteWithChildren
  "/(app)/_auth/onboarding": typeof appAuthOnboardingRouteRoute
  "/(app)/_auth/rabattkoder": typeof appAuthRabattkoderRouteRoute
  "/(app)/_auth/reviews": typeof appAuthReviewsRouteRoute
  "/(app)/_auth/settings": typeof appAuthSettingsRouteRouteWithChildren
  "/(app)/_auth/support-chat": typeof appAuthSupportChatRouteRoute
  "/(app)/_auth/": typeof appAuthIndexRoute
  "/(app)/_auth/event/": typeof appAuthEventIndexRouteRoute
  "/(app)/_auth/jobs/": typeof appAuthJobsIndexRouteRoute
  "/(app)/_auth/settings/": typeof appAuthSettingsIndexRouteRoute
  "/(app)/_auth/bikes-for-sale/$bikeId": typeof appAuthBikesForSaleBikeIdRouteRouteWithChildren
  "/(app)/_auth/bikes-for-sale/invoices": typeof appAuthBikesForSaleInvoicesRouteRoute
  "/(app)/_auth/bikes-for-sale/new": typeof appAuthBikesForSaleNewRouteRoute
  "/(app)/_auth/customers/$customerId": typeof appAuthCustomersCustomerIdRouteRouteWithChildren
  "/(app)/_auth/event/$eventId": typeof appAuthEventEventIdRouteRouteWithChildren
  "/(app)/_auth/event/create": typeof appAuthEventCreateRouteRoute
  "/(app)/_auth/jobs/$jobId": typeof appAuthJobsJobIdRouteRouteWithChildren
  "/(app)/_auth/jobs/book": typeof appAuthJobsBookRouteRoute
  "/(app)/_auth/jobs/create": typeof appAuthJobsCreateRouteRoute
  "/(app)/_auth/jobs/new-reception": typeof appAuthJobsNewReceptionRouteRoute
  "/(app)/_auth/messages/$jobId": typeof appAuthMessagesJobIdRouteRoute
  "/(app)/_auth/settings/action-visibility": typeof appAuthSettingsActionVisibilityRouteRoute
  "/(app)/_auth/settings/bikes-for-sale": typeof appAuthSettingsBikesForSaleRouteRoute
  "/(app)/_auth/settings/bookable-slots": typeof appAuthSettingsBookableSlotsRouteRoute
  "/(app)/_auth/settings/booking-form-text": typeof appAuthSettingsBookingFormTextRouteRoute
  "/(app)/_auth/settings/booking-order": typeof appAuthSettingsBookingOrderRouteRoute
  "/(app)/_auth/settings/communication": typeof appAuthSettingsCommunicationRouteRouteWithChildren
  "/(app)/_auth/settings/companies": typeof appAuthSettingsCompaniesRouteRouteWithChildren
  "/(app)/_auth/settings/custom-sections": typeof appAuthSettingsCustomSectionsRouteRoute
  "/(app)/_auth/settings/damper-service": typeof appAuthSettingsDamperServiceRouteRoute
  "/(app)/_auth/settings/emergency-service": typeof appAuthSettingsEmergencyServiceRouteRoute
  "/(app)/_auth/settings/fee": typeof appAuthSettingsFeeRouteRoute
  "/(app)/_auth/settings/kassakoppling": typeof appAuthSettingsKassakopplingRouteRoute
  "/(app)/_auth/settings/labels": typeof appAuthSettingsLabelsRouteRoute
  "/(app)/_auth/settings/lead-time": typeof appAuthSettingsLeadTimeRouteRoute
  "/(app)/_auth/settings/parts": typeof appAuthSettingsPartsRouteRoute
  "/(app)/_auth/settings/price-list": typeof appAuthSettingsPriceListRouteRoute
  "/(app)/_auth/settings/prices": typeof appAuthSettingsPricesRouteRoute
  "/(app)/_auth/settings/reception": typeof appAuthSettingsReceptionRouteRoute
  "/(app)/_auth/settings/reviews": typeof appAuthSettingsReviewsRouteRoute
  "/(app)/_auth/settings/service-packages": typeof appAuthSettingsServicePackagesRouteRoute
  "/(app)/_auth/settings/service-reminders": typeof appAuthSettingsServiceRemindersRouteRoute
  "/(app)/_auth/settings/services": typeof appAuthSettingsServicesRouteRoute
  "/(app)/_auth/settings/storage-locations": typeof appAuthSettingsStorageLocationsRouteRoute
  "/(app)/_auth/settings/tire-hotel": typeof appAuthSettingsTireHotelRouteRoute
  "/(app)/_auth/settings/user-accounts": typeof appAuthSettingsUserAccountsRouteRoute
  "/(app)/_auth/settings/wash": typeof appAuthSettingsWashRouteRoute
  "/(app)/_auth/settings/widget-customization": typeof appAuthSettingsWidgetCustomizationRouteRoute
  "/(app)/_auth/tire-hotel/$tireStorageId": typeof appAuthTireHotelTireStorageIdRouteRoute
  "/(app)/_auth/settings/booking-rules-and-opening-hours": typeof appAuthSettingsBookingRulesAndOpeningHoursRouteLazyRoute
  "/(app)/_auth/settings/inspection-order": typeof appAuthSettingsInspectionOrderRouteLazyRoute
  "/(app)/_auth/alfred-impact/": typeof appAuthAlfredImpactIndexRoute
  "/(app)/_auth/all-jobs/": typeof appAuthAllJobsIndexRoute
  "/(app)/_auth/automatic-emails/": typeof appAuthAutomaticEmailsIndexRoute
  "/(app)/_auth/bikes-for-sale/": typeof appAuthBikesForSaleIndexRoute
  "/(app)/_auth/company-jobs/": typeof appAuthCompanyJobsIndexRoute
  "/(app)/_auth/customer-club/": typeof appAuthCustomerClubIndexRoute
  "/(app)/_auth/customers/": typeof appAuthCustomersIndexRoute
  "/(app)/_auth/inspection-simulator/": typeof appAuthInspectionSimulatorIndexRoute
  "/(app)/_auth/prestationer/": typeof appAuthPrestationerIndexRoute
  "/(app)/_auth/price-simulator/": typeof appAuthPriceSimulatorIndexRoute
  "/(app)/_auth/products/": typeof appAuthProductsIndexRoute
  "/(app)/_auth/simulation-settings/": typeof appAuthSimulationSettingsIndexRoute
  "/(app)/_auth/statistik/": typeof appAuthStatistikIndexRoute
  "/(app)/_auth/tire-hotel/": typeof appAuthTireHotelIndexRoute
  "/(app)/_auth/trends/": typeof appAuthTrendsIndexRoute
  "/(app)/_auth/settings/communication/": typeof appAuthSettingsCommunicationIndexRouteRoute
  "/(app)/_auth/settings/companies/": typeof appAuthSettingsCompaniesIndexRouteRoute
  "/(app)/_auth/bikes-for-sale/$bikeId/inspection": typeof appAuthBikesForSaleBikeIdInspectionRouteRoute
  "/(app)/_auth/bikes-for-sale/$bikeId/listing": typeof appAuthBikesForSaleBikeIdListingRouteRoute
  "/(app)/_auth/event/$eventId/edit": typeof appAuthEventEventIdEditRouteRoute
  "/(app)/_auth/jobs/$jobId/inspection": typeof appAuthJobsJobIdInspectionRouteRoute
  "/(app)/_auth/jobs/$jobId/new-reception": typeof appAuthJobsJobIdNewReceptionRouteRoute
  "/(app)/_auth/messages/customers/$customerId": typeof appAuthMessagesCustomersCustomerIdRouteRoute
  "/(app)/_auth/settings/communication/booking": typeof appAuthSettingsCommunicationBookingRouteRoute
  "/(app)/_auth/settings/communication/general": typeof appAuthSettingsCommunicationGeneralRouteRoute
  "/(app)/_auth/settings/communication/notifications": typeof appAuthSettingsCommunicationNotificationsRouteRoute
  "/(app)/_auth/settings/communication/pickup": typeof appAuthSettingsCommunicationPickupRouteRoute
  "/(app)/_auth/settings/communication/reception": typeof appAuthSettingsCommunicationReceptionRouteRoute
  "/(app)/_auth/settings/communication/reminders": typeof appAuthSettingsCommunicationRemindersRouteRoute
  "/(app)/_auth/settings/communication/templates": typeof appAuthSettingsCommunicationTemplatesRouteRoute
  "/(app)/_auth/settings/companies/$companyId": typeof appAuthSettingsCompaniesCompanyIdRouteRouteWithChildren
  "/(app)/_auth/prestationer/$mechanicId/": typeof appAuthPrestationerMechanicIdIndexRoute
  "/(app)/_auth/bikes-for-sale/$bikeId/": typeof appAuthBikesForSaleBikeIdIndexLazyRoute
  "/(app)/_auth/customers/$customerId/": typeof appAuthCustomersCustomerIdIndexLazyRoute
  "/(app)/_auth/event/$eventId/": typeof appAuthEventEventIdIndexLazyRoute
  "/(app)/_auth/jobs/$jobId/": typeof appAuthJobsJobIdIndexLazyRoute
  "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber": typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberRouteRouteWithChildren
  "/(app)/_auth/customers/$customerId/bikes/$bikeId": typeof appAuthCustomersCustomerIdBikesBikeIdRouteRoute
  "/(app)/_auth/settings/companies/$companyId/": typeof appAuthSettingsCompaniesCompanyIdIndexLazyRoute
  "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/": typeof appAuthCompaniesCompanyIdFakturorInvoiceNumberIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/login"
    | "/reset-password"
    | "/set-new-password"
    | "/"
    | "/bikes-for-sale"
    | "/booking-qr-code"
    | "/calendar"
    | "/check-in"
    | "/event"
    | "/jobs"
    | "/jobs-new"
    | "/julo-updates"
    | "/messages"
    | "/onboarding"
    | "/rabattkoder"
    | "/reviews"
    | "/settings"
    | "/support-chat"
    | "/event/"
    | "/jobs/"
    | "/settings/"
    | "/bikes-for-sale/$bikeId"
    | "/bikes-for-sale/invoices"
    | "/bikes-for-sale/new"
    | "/customers/$customerId"
    | "/event/$eventId"
    | "/event/create"
    | "/jobs/$jobId"
    | "/jobs/book"
    | "/jobs/create"
    | "/jobs/new-reception"
    | "/messages/$jobId"
    | "/settings/action-visibility"
    | "/settings/bikes-for-sale"
    | "/settings/bookable-slots"
    | "/settings/booking-form-text"
    | "/settings/booking-order"
    | "/settings/communication"
    | "/settings/companies"
    | "/settings/custom-sections"
    | "/settings/damper-service"
    | "/settings/emergency-service"
    | "/settings/fee"
    | "/settings/kassakoppling"
    | "/settings/labels"
    | "/settings/lead-time"
    | "/settings/parts"
    | "/settings/price-list"
    | "/settings/prices"
    | "/settings/reception"
    | "/settings/reviews"
    | "/settings/service-packages"
    | "/settings/service-reminders"
    | "/settings/services"
    | "/settings/storage-locations"
    | "/settings/tire-hotel"
    | "/settings/user-accounts"
    | "/settings/wash"
    | "/settings/widget-customization"
    | "/tire-hotel/$tireStorageId"
    | "/settings/booking-rules-and-opening-hours"
    | "/settings/inspection-order"
    | "/alfred-impact"
    | "/all-jobs"
    | "/automatic-emails"
    | "/bikes-for-sale/"
    | "/company-jobs"
    | "/customer-club"
    | "/customers"
    | "/inspection-simulator"
    | "/prestationer"
    | "/price-simulator"
    | "/products"
    | "/simulation-settings"
    | "/statistik"
    | "/tire-hotel"
    | "/trends"
    | "/settings/communication/"
    | "/settings/companies/"
    | "/bikes-for-sale/$bikeId/inspection"
    | "/bikes-for-sale/$bikeId/listing"
    | "/event/$eventId/edit"
    | "/jobs/$jobId/inspection"
    | "/jobs/$jobId/new-reception"
    | "/messages/customers/$customerId"
    | "/settings/communication/booking"
    | "/settings/communication/general"
    | "/settings/communication/notifications"
    | "/settings/communication/pickup"
    | "/settings/communication/reception"
    | "/settings/communication/reminders"
    | "/settings/communication/templates"
    | "/settings/companies/$companyId"
    | "/prestationer/$mechanicId"
    | "/bikes-for-sale/$bikeId/"
    | "/customers/$customerId/"
    | "/event/$eventId/"
    | "/jobs/$jobId/"
    | "/companies/$companyId/fakturor/$invoiceNumber"
    | "/customers/$customerId/bikes/$bikeId"
    | "/settings/companies/$companyId/"
    | "/companies/$companyId/fakturor/$invoiceNumber/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/reset-password"
    | "/set-new-password"
    | "/booking-qr-code"
    | "/calendar"
    | "/check-in"
    | "/jobs-new"
    | "/julo-updates"
    | "/messages"
    | "/onboarding"
    | "/rabattkoder"
    | "/reviews"
    | "/support-chat"
    | "/"
    | "/event"
    | "/jobs"
    | "/settings"
    | "/bikes-for-sale/invoices"
    | "/bikes-for-sale/new"
    | "/event/create"
    | "/jobs/book"
    | "/jobs/create"
    | "/jobs/new-reception"
    | "/messages/$jobId"
    | "/settings/action-visibility"
    | "/settings/bikes-for-sale"
    | "/settings/bookable-slots"
    | "/settings/booking-form-text"
    | "/settings/booking-order"
    | "/settings/custom-sections"
    | "/settings/damper-service"
    | "/settings/emergency-service"
    | "/settings/fee"
    | "/settings/kassakoppling"
    | "/settings/labels"
    | "/settings/lead-time"
    | "/settings/parts"
    | "/settings/price-list"
    | "/settings/prices"
    | "/settings/reception"
    | "/settings/reviews"
    | "/settings/service-packages"
    | "/settings/service-reminders"
    | "/settings/services"
    | "/settings/storage-locations"
    | "/settings/tire-hotel"
    | "/settings/user-accounts"
    | "/settings/wash"
    | "/settings/widget-customization"
    | "/tire-hotel/$tireStorageId"
    | "/settings/booking-rules-and-opening-hours"
    | "/settings/inspection-order"
    | "/alfred-impact"
    | "/all-jobs"
    | "/automatic-emails"
    | "/bikes-for-sale"
    | "/company-jobs"
    | "/customer-club"
    | "/customers"
    | "/inspection-simulator"
    | "/prestationer"
    | "/price-simulator"
    | "/products"
    | "/simulation-settings"
    | "/statistik"
    | "/tire-hotel"
    | "/trends"
    | "/settings/communication"
    | "/settings/companies"
    | "/bikes-for-sale/$bikeId/inspection"
    | "/bikes-for-sale/$bikeId/listing"
    | "/event/$eventId/edit"
    | "/jobs/$jobId/inspection"
    | "/jobs/$jobId/new-reception"
    | "/messages/customers/$customerId"
    | "/settings/communication/booking"
    | "/settings/communication/general"
    | "/settings/communication/notifications"
    | "/settings/communication/pickup"
    | "/settings/communication/reception"
    | "/settings/communication/reminders"
    | "/settings/communication/templates"
    | "/prestationer/$mechanicId"
    | "/bikes-for-sale/$bikeId"
    | "/customers/$customerId"
    | "/event/$eventId"
    | "/jobs/$jobId"
    | "/customers/$customerId/bikes/$bikeId"
    | "/settings/companies/$companyId"
    | "/companies/$companyId/fakturor/$invoiceNumber"
  id:
    | "__root__"
    | "/(auth)/login"
    | "/(auth)/reset-password"
    | "/(auth)/set-new-password"
    | "/(app)"
    | "/(app)/_auth"
    | "/(app)/_auth/bikes-for-sale"
    | "/(app)/_auth/booking-qr-code"
    | "/(app)/_auth/calendar"
    | "/(app)/_auth/check-in"
    | "/(app)/_auth/event"
    | "/(app)/_auth/jobs"
    | "/(app)/_auth/jobs-new"
    | "/(app)/_auth/julo-updates"
    | "/(app)/_auth/messages"
    | "/(app)/_auth/onboarding"
    | "/(app)/_auth/rabattkoder"
    | "/(app)/_auth/reviews"
    | "/(app)/_auth/settings"
    | "/(app)/_auth/support-chat"
    | "/(app)/_auth/"
    | "/(app)/_auth/event/"
    | "/(app)/_auth/jobs/"
    | "/(app)/_auth/settings/"
    | "/(app)/_auth/bikes-for-sale/$bikeId"
    | "/(app)/_auth/bikes-for-sale/invoices"
    | "/(app)/_auth/bikes-for-sale/new"
    | "/(app)/_auth/customers/$customerId"
    | "/(app)/_auth/event/$eventId"
    | "/(app)/_auth/event/create"
    | "/(app)/_auth/jobs/$jobId"
    | "/(app)/_auth/jobs/book"
    | "/(app)/_auth/jobs/create"
    | "/(app)/_auth/jobs/new-reception"
    | "/(app)/_auth/messages/$jobId"
    | "/(app)/_auth/settings/action-visibility"
    | "/(app)/_auth/settings/bikes-for-sale"
    | "/(app)/_auth/settings/bookable-slots"
    | "/(app)/_auth/settings/booking-form-text"
    | "/(app)/_auth/settings/booking-order"
    | "/(app)/_auth/settings/communication"
    | "/(app)/_auth/settings/companies"
    | "/(app)/_auth/settings/custom-sections"
    | "/(app)/_auth/settings/damper-service"
    | "/(app)/_auth/settings/emergency-service"
    | "/(app)/_auth/settings/fee"
    | "/(app)/_auth/settings/kassakoppling"
    | "/(app)/_auth/settings/labels"
    | "/(app)/_auth/settings/lead-time"
    | "/(app)/_auth/settings/parts"
    | "/(app)/_auth/settings/price-list"
    | "/(app)/_auth/settings/prices"
    | "/(app)/_auth/settings/reception"
    | "/(app)/_auth/settings/reviews"
    | "/(app)/_auth/settings/service-packages"
    | "/(app)/_auth/settings/service-reminders"
    | "/(app)/_auth/settings/services"
    | "/(app)/_auth/settings/storage-locations"
    | "/(app)/_auth/settings/tire-hotel"
    | "/(app)/_auth/settings/user-accounts"
    | "/(app)/_auth/settings/wash"
    | "/(app)/_auth/settings/widget-customization"
    | "/(app)/_auth/tire-hotel/$tireStorageId"
    | "/(app)/_auth/settings/booking-rules-and-opening-hours"
    | "/(app)/_auth/settings/inspection-order"
    | "/(app)/_auth/alfred-impact/"
    | "/(app)/_auth/all-jobs/"
    | "/(app)/_auth/automatic-emails/"
    | "/(app)/_auth/bikes-for-sale/"
    | "/(app)/_auth/company-jobs/"
    | "/(app)/_auth/customer-club/"
    | "/(app)/_auth/customers/"
    | "/(app)/_auth/inspection-simulator/"
    | "/(app)/_auth/prestationer/"
    | "/(app)/_auth/price-simulator/"
    | "/(app)/_auth/products/"
    | "/(app)/_auth/simulation-settings/"
    | "/(app)/_auth/statistik/"
    | "/(app)/_auth/tire-hotel/"
    | "/(app)/_auth/trends/"
    | "/(app)/_auth/settings/communication/"
    | "/(app)/_auth/settings/companies/"
    | "/(app)/_auth/bikes-for-sale/$bikeId/inspection"
    | "/(app)/_auth/bikes-for-sale/$bikeId/listing"
    | "/(app)/_auth/event/$eventId/edit"
    | "/(app)/_auth/jobs/$jobId/inspection"
    | "/(app)/_auth/jobs/$jobId/new-reception"
    | "/(app)/_auth/messages/customers/$customerId"
    | "/(app)/_auth/settings/communication/booking"
    | "/(app)/_auth/settings/communication/general"
    | "/(app)/_auth/settings/communication/notifications"
    | "/(app)/_auth/settings/communication/pickup"
    | "/(app)/_auth/settings/communication/reception"
    | "/(app)/_auth/settings/communication/reminders"
    | "/(app)/_auth/settings/communication/templates"
    | "/(app)/_auth/settings/companies/$companyId"
    | "/(app)/_auth/prestationer/$mechanicId/"
    | "/(app)/_auth/bikes-for-sale/$bikeId/"
    | "/(app)/_auth/customers/$customerId/"
    | "/(app)/_auth/event/$eventId/"
    | "/(app)/_auth/jobs/$jobId/"
    | "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber"
    | "/(app)/_auth/customers/$customerId/bikes/$bikeId"
    | "/(app)/_auth/settings/companies/$companyId/"
    | "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  authLoginRouteRoute: typeof authLoginRouteRoute
  authResetPasswordRouteRoute: typeof authResetPasswordRouteRoute
  authSetNewPasswordRouteRoute: typeof authSetNewPasswordRouteRoute
  appRoute: typeof appRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  authLoginRouteRoute: authLoginRouteRoute,
  authResetPasswordRouteRoute: authResetPasswordRouteRoute,
  authSetNewPasswordRouteRoute: authSetNewPasswordRouteRoute,
  appRoute: appRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(auth)/login",
        "/(auth)/reset-password",
        "/(auth)/set-new-password",
        "/(app)"
      ]
    },
    "/(auth)/login": {
      "filePath": "(auth)/login/route.tsx"
    },
    "/(auth)/reset-password": {
      "filePath": "(auth)/reset-password/route.tsx"
    },
    "/(auth)/set-new-password": {
      "filePath": "(auth)/set-new-password/route.tsx"
    },
    "/(app)": {
      "filePath": "(app)",
      "children": [
        "/(app)/_auth"
      ]
    },
    "/(app)/_auth": {
      "filePath": "(app)/_auth.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/_auth/bikes-for-sale",
        "/(app)/_auth/booking-qr-code",
        "/(app)/_auth/calendar",
        "/(app)/_auth/check-in",
        "/(app)/_auth/event",
        "/(app)/_auth/jobs",
        "/(app)/_auth/jobs-new",
        "/(app)/_auth/julo-updates",
        "/(app)/_auth/messages",
        "/(app)/_auth/onboarding",
        "/(app)/_auth/rabattkoder",
        "/(app)/_auth/reviews",
        "/(app)/_auth/settings",
        "/(app)/_auth/support-chat",
        "/(app)/_auth/",
        "/(app)/_auth/customers/$customerId",
        "/(app)/_auth/tire-hotel/$tireStorageId",
        "/(app)/_auth/alfred-impact/",
        "/(app)/_auth/all-jobs/",
        "/(app)/_auth/automatic-emails/",
        "/(app)/_auth/company-jobs/",
        "/(app)/_auth/customer-club/",
        "/(app)/_auth/customers/",
        "/(app)/_auth/inspection-simulator/",
        "/(app)/_auth/prestationer/",
        "/(app)/_auth/price-simulator/",
        "/(app)/_auth/products/",
        "/(app)/_auth/simulation-settings/",
        "/(app)/_auth/statistik/",
        "/(app)/_auth/tire-hotel/",
        "/(app)/_auth/trends/",
        "/(app)/_auth/prestationer/$mechanicId/",
        "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber"
      ]
    },
    "/(app)/_auth/bikes-for-sale": {
      "filePath": "(app)/_auth/bikes-for-sale/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/bikes-for-sale/$bikeId",
        "/(app)/_auth/bikes-for-sale/invoices",
        "/(app)/_auth/bikes-for-sale/new",
        "/(app)/_auth/bikes-for-sale/"
      ]
    },
    "/(app)/_auth/booking-qr-code": {
      "filePath": "(app)/_auth/booking-qr-code/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/calendar": {
      "filePath": "(app)/_auth/calendar/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/check-in": {
      "filePath": "(app)/_auth/check-in/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/event": {
      "filePath": "(app)/_auth/event/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/event/",
        "/(app)/_auth/event/$eventId",
        "/(app)/_auth/event/create"
      ]
    },
    "/(app)/_auth/jobs": {
      "filePath": "(app)/_auth/jobs/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/jobs/",
        "/(app)/_auth/jobs/$jobId",
        "/(app)/_auth/jobs/book",
        "/(app)/_auth/jobs/create",
        "/(app)/_auth/jobs/new-reception"
      ]
    },
    "/(app)/_auth/jobs-new": {
      "filePath": "(app)/_auth/jobs-new/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/julo-updates": {
      "filePath": "(app)/_auth/julo-updates/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/messages": {
      "filePath": "(app)/_auth/messages/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/messages/$jobId",
        "/(app)/_auth/messages/customers/$customerId"
      ]
    },
    "/(app)/_auth/onboarding": {
      "filePath": "(app)/_auth/onboarding/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/rabattkoder": {
      "filePath": "(app)/_auth/rabattkoder/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/reviews": {
      "filePath": "(app)/_auth/reviews/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/settings": {
      "filePath": "(app)/_auth/settings/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/settings/",
        "/(app)/_auth/settings/action-visibility",
        "/(app)/_auth/settings/bikes-for-sale",
        "/(app)/_auth/settings/bookable-slots",
        "/(app)/_auth/settings/booking-form-text",
        "/(app)/_auth/settings/booking-order",
        "/(app)/_auth/settings/communication",
        "/(app)/_auth/settings/companies",
        "/(app)/_auth/settings/custom-sections",
        "/(app)/_auth/settings/damper-service",
        "/(app)/_auth/settings/emergency-service",
        "/(app)/_auth/settings/fee",
        "/(app)/_auth/settings/kassakoppling",
        "/(app)/_auth/settings/labels",
        "/(app)/_auth/settings/lead-time",
        "/(app)/_auth/settings/parts",
        "/(app)/_auth/settings/price-list",
        "/(app)/_auth/settings/prices",
        "/(app)/_auth/settings/reception",
        "/(app)/_auth/settings/reviews",
        "/(app)/_auth/settings/service-packages",
        "/(app)/_auth/settings/service-reminders",
        "/(app)/_auth/settings/services",
        "/(app)/_auth/settings/storage-locations",
        "/(app)/_auth/settings/tire-hotel",
        "/(app)/_auth/settings/user-accounts",
        "/(app)/_auth/settings/wash",
        "/(app)/_auth/settings/widget-customization",
        "/(app)/_auth/settings/booking-rules-and-opening-hours",
        "/(app)/_auth/settings/inspection-order"
      ]
    },
    "/(app)/_auth/support-chat": {
      "filePath": "(app)/_auth/support-chat/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/": {
      "filePath": "(app)/_auth/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/event/": {
      "filePath": "(app)/_auth/event/index/route.tsx",
      "parent": "/(app)/_auth/event"
    },
    "/(app)/_auth/jobs/": {
      "filePath": "(app)/_auth/jobs/index/route.tsx",
      "parent": "/(app)/_auth/jobs"
    },
    "/(app)/_auth/settings/": {
      "filePath": "(app)/_auth/settings/index/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/bikes-for-sale/$bikeId": {
      "filePath": "(app)/_auth/bikes-for-sale/$bikeId/route.tsx",
      "parent": "/(app)/_auth/bikes-for-sale",
      "children": [
        "/(app)/_auth/bikes-for-sale/$bikeId/inspection",
        "/(app)/_auth/bikes-for-sale/$bikeId/listing",
        "/(app)/_auth/bikes-for-sale/$bikeId/"
      ]
    },
    "/(app)/_auth/bikes-for-sale/invoices": {
      "filePath": "(app)/_auth/bikes-for-sale/invoices/route.tsx",
      "parent": "/(app)/_auth/bikes-for-sale"
    },
    "/(app)/_auth/bikes-for-sale/new": {
      "filePath": "(app)/_auth/bikes-for-sale/new/route.tsx",
      "parent": "/(app)/_auth/bikes-for-sale"
    },
    "/(app)/_auth/customers/$customerId": {
      "filePath": "(app)/_auth/customers/$customerId/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/customers/$customerId/",
        "/(app)/_auth/customers/$customerId/bikes/$bikeId"
      ]
    },
    "/(app)/_auth/event/$eventId": {
      "filePath": "(app)/_auth/event/$eventId/route.tsx",
      "parent": "/(app)/_auth/event",
      "children": [
        "/(app)/_auth/event/$eventId/edit",
        "/(app)/_auth/event/$eventId/"
      ]
    },
    "/(app)/_auth/event/create": {
      "filePath": "(app)/_auth/event/create/route.tsx",
      "parent": "/(app)/_auth/event"
    },
    "/(app)/_auth/jobs/$jobId": {
      "filePath": "(app)/_auth/jobs/$jobId/route.tsx",
      "parent": "/(app)/_auth/jobs",
      "children": [
        "/(app)/_auth/jobs/$jobId/inspection",
        "/(app)/_auth/jobs/$jobId/new-reception",
        "/(app)/_auth/jobs/$jobId/"
      ]
    },
    "/(app)/_auth/jobs/book": {
      "filePath": "(app)/_auth/jobs/book/route.tsx",
      "parent": "/(app)/_auth/jobs"
    },
    "/(app)/_auth/jobs/create": {
      "filePath": "(app)/_auth/jobs/create/route.tsx",
      "parent": "/(app)/_auth/jobs"
    },
    "/(app)/_auth/jobs/new-reception": {
      "filePath": "(app)/_auth/jobs/new-reception/route.tsx",
      "parent": "/(app)/_auth/jobs"
    },
    "/(app)/_auth/messages/$jobId": {
      "filePath": "(app)/_auth/messages/$jobId/route.tsx",
      "parent": "/(app)/_auth/messages"
    },
    "/(app)/_auth/settings/action-visibility": {
      "filePath": "(app)/_auth/settings/action-visibility/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/bikes-for-sale": {
      "filePath": "(app)/_auth/settings/bikes-for-sale/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/bookable-slots": {
      "filePath": "(app)/_auth/settings/bookable-slots/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/booking-form-text": {
      "filePath": "(app)/_auth/settings/booking-form-text/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/booking-order": {
      "filePath": "(app)/_auth/settings/booking-order/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/communication": {
      "filePath": "(app)/_auth/settings/communication/route.tsx",
      "parent": "/(app)/_auth/settings",
      "children": [
        "/(app)/_auth/settings/communication/",
        "/(app)/_auth/settings/communication/booking",
        "/(app)/_auth/settings/communication/general",
        "/(app)/_auth/settings/communication/notifications",
        "/(app)/_auth/settings/communication/pickup",
        "/(app)/_auth/settings/communication/reception",
        "/(app)/_auth/settings/communication/reminders",
        "/(app)/_auth/settings/communication/templates"
      ]
    },
    "/(app)/_auth/settings/companies": {
      "filePath": "(app)/_auth/settings/companies/route.tsx",
      "parent": "/(app)/_auth/settings",
      "children": [
        "/(app)/_auth/settings/companies/",
        "/(app)/_auth/settings/companies/$companyId"
      ]
    },
    "/(app)/_auth/settings/custom-sections": {
      "filePath": "(app)/_auth/settings/custom-sections/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/damper-service": {
      "filePath": "(app)/_auth/settings/damper-service/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/emergency-service": {
      "filePath": "(app)/_auth/settings/emergency-service/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/fee": {
      "filePath": "(app)/_auth/settings/fee/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/kassakoppling": {
      "filePath": "(app)/_auth/settings/kassakoppling/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/labels": {
      "filePath": "(app)/_auth/settings/labels/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/lead-time": {
      "filePath": "(app)/_auth/settings/lead-time/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/parts": {
      "filePath": "(app)/_auth/settings/parts/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/price-list": {
      "filePath": "(app)/_auth/settings/price-list/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/prices": {
      "filePath": "(app)/_auth/settings/prices/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/reception": {
      "filePath": "(app)/_auth/settings/reception/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/reviews": {
      "filePath": "(app)/_auth/settings/reviews/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/service-packages": {
      "filePath": "(app)/_auth/settings/service-packages/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/service-reminders": {
      "filePath": "(app)/_auth/settings/service-reminders/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/services": {
      "filePath": "(app)/_auth/settings/services/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/storage-locations": {
      "filePath": "(app)/_auth/settings/storage-locations/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/tire-hotel": {
      "filePath": "(app)/_auth/settings/tire-hotel/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/user-accounts": {
      "filePath": "(app)/_auth/settings/user-accounts/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/wash": {
      "filePath": "(app)/_auth/settings/wash/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/widget-customization": {
      "filePath": "(app)/_auth/settings/widget-customization/route.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/tire-hotel/$tireStorageId": {
      "filePath": "(app)/_auth/tire-hotel/$tireStorageId/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/settings/booking-rules-and-opening-hours": {
      "filePath": "(app)/_auth/settings/booking-rules-and-opening-hours/route.lazy.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/settings/inspection-order": {
      "filePath": "(app)/_auth/settings/inspection-order/route.lazy.tsx",
      "parent": "/(app)/_auth/settings"
    },
    "/(app)/_auth/alfred-impact/": {
      "filePath": "(app)/_auth/alfred-impact/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/all-jobs/": {
      "filePath": "(app)/_auth/all-jobs/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/automatic-emails/": {
      "filePath": "(app)/_auth/automatic-emails/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/bikes-for-sale/": {
      "filePath": "(app)/_auth/bikes-for-sale/index.tsx",
      "parent": "/(app)/_auth/bikes-for-sale"
    },
    "/(app)/_auth/company-jobs/": {
      "filePath": "(app)/_auth/company-jobs/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/customer-club/": {
      "filePath": "(app)/_auth/customer-club/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/customers/": {
      "filePath": "(app)/_auth/customers/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/inspection-simulator/": {
      "filePath": "(app)/_auth/inspection-simulator/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/prestationer/": {
      "filePath": "(app)/_auth/prestationer/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/price-simulator/": {
      "filePath": "(app)/_auth/price-simulator/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/products/": {
      "filePath": "(app)/_auth/products/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/simulation-settings/": {
      "filePath": "(app)/_auth/simulation-settings/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/statistik/": {
      "filePath": "(app)/_auth/statistik/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/tire-hotel/": {
      "filePath": "(app)/_auth/tire-hotel/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/trends/": {
      "filePath": "(app)/_auth/trends/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/settings/communication/": {
      "filePath": "(app)/_auth/settings/communication/index/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/companies/": {
      "filePath": "(app)/_auth/settings/companies/index/route.tsx",
      "parent": "/(app)/_auth/settings/companies"
    },
    "/(app)/_auth/bikes-for-sale/$bikeId/inspection": {
      "filePath": "(app)/_auth/bikes-for-sale/$bikeId/inspection/route.tsx",
      "parent": "/(app)/_auth/bikes-for-sale/$bikeId"
    },
    "/(app)/_auth/bikes-for-sale/$bikeId/listing": {
      "filePath": "(app)/_auth/bikes-for-sale/$bikeId/listing/route.tsx",
      "parent": "/(app)/_auth/bikes-for-sale/$bikeId"
    },
    "/(app)/_auth/event/$eventId/edit": {
      "filePath": "(app)/_auth/event/$eventId/edit/route.tsx",
      "parent": "/(app)/_auth/event/$eventId"
    },
    "/(app)/_auth/jobs/$jobId/inspection": {
      "filePath": "(app)/_auth/jobs/$jobId/inspection/route.tsx",
      "parent": "/(app)/_auth/jobs/$jobId"
    },
    "/(app)/_auth/jobs/$jobId/new-reception": {
      "filePath": "(app)/_auth/jobs/$jobId/new-reception/route.tsx",
      "parent": "/(app)/_auth/jobs/$jobId"
    },
    "/(app)/_auth/messages/customers/$customerId": {
      "filePath": "(app)/_auth/messages/customers/$customerId/route.tsx",
      "parent": "/(app)/_auth/messages"
    },
    "/(app)/_auth/settings/communication/booking": {
      "filePath": "(app)/_auth/settings/communication/booking/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/general": {
      "filePath": "(app)/_auth/settings/communication/general/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/notifications": {
      "filePath": "(app)/_auth/settings/communication/notifications/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/pickup": {
      "filePath": "(app)/_auth/settings/communication/pickup/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/reception": {
      "filePath": "(app)/_auth/settings/communication/reception/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/reminders": {
      "filePath": "(app)/_auth/settings/communication/reminders/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/communication/templates": {
      "filePath": "(app)/_auth/settings/communication/templates/route.tsx",
      "parent": "/(app)/_auth/settings/communication"
    },
    "/(app)/_auth/settings/companies/$companyId": {
      "filePath": "(app)/_auth/settings/companies/$companyId/route.tsx",
      "parent": "/(app)/_auth/settings/companies",
      "children": [
        "/(app)/_auth/settings/companies/$companyId/"
      ]
    },
    "/(app)/_auth/prestationer/$mechanicId/": {
      "filePath": "(app)/_auth/prestationer/$mechanicId/index.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/bikes-for-sale/$bikeId/": {
      "filePath": "(app)/_auth/bikes-for-sale/$bikeId/index.lazy.tsx",
      "parent": "/(app)/_auth/bikes-for-sale/$bikeId"
    },
    "/(app)/_auth/customers/$customerId/": {
      "filePath": "(app)/_auth/customers/$customerId/index.lazy.tsx",
      "parent": "/(app)/_auth/customers/$customerId"
    },
    "/(app)/_auth/event/$eventId/": {
      "filePath": "(app)/_auth/event/$eventId/index.lazy.tsx",
      "parent": "/(app)/_auth/event/$eventId"
    },
    "/(app)/_auth/jobs/$jobId/": {
      "filePath": "(app)/_auth/jobs/$jobId/index.lazy.tsx",
      "parent": "/(app)/_auth/jobs/$jobId"
    },
    "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber": {
      "filePath": "(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/"
      ]
    },
    "/(app)/_auth/customers/$customerId/bikes/$bikeId": {
      "filePath": "(app)/_auth/customers/$customerId/bikes/$bikeId/route.tsx",
      "parent": "/(app)/_auth/customers/$customerId"
    },
    "/(app)/_auth/settings/companies/$companyId/": {
      "filePath": "(app)/_auth/settings/companies/$companyId/index.lazy.tsx",
      "parent": "/(app)/_auth/settings/companies/$companyId"
    },
    "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/": {
      "filePath": "(app)/_auth/companies/$companyId/fakturor/$invoiceNumber/index.lazy.tsx",
      "parent": "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber"
    }
  }
}
ROUTE_MANIFEST_END */
